// src/components/Shared/Avatar.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    border-radius: 50%;\n    ",
        ";\n    ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  0% { background-position: -1300px 0; }\n  100% { background-position: 1300px 0; }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n\n  height: ",
        "px;\n  width: ",
        "px;\n\n  border-radius: 50%;\n  border: 1px solid ",
        ";\n\n  animation: ",
        " 3.1s linear infinite;\n  background: ",
        ";\n  background: linear-gradient(90deg, ",
        " 9%, ",
        " 18%, ",
        " 31%);\n  background-size: 1300px 100%;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n    box-sizing: border-box;\n    position: fixed;\n    top: calc(",
        "px + env(safe-area-inset-top));\n    display: ",
        ";\n    width: 100%;\n    background-color: rgba(255,255,255, 0.1);\n    z-index: 100;\n    transition: top 500ms ease-in-out;\n    justify-content: center;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n    margin:10px;\n    width: calc(100% - 20px);\n    max-width: ",
        "px;\n    background-color: ",
        ";\n    color: ",
        ";\n    font-size: 1rem;\n    border-radius: 6px;\n    display: flex;\n    padding:12px;\n\n    div { flex: 1 1 auto }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n    flex: 0 0 24px;\n    svg { height: 16px; cursor: pointer; }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  justify-items: center;\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  height: 40px !important;\n  line-height: 40px !important;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-items: center;\n  justify-content: center;\n\n  svg {\n    height: 22px;\n    width: 22px;\n    display: block;\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n\n  background-color: ",
        ";\n  color: ",
        ";\n  height: 40px;\n  padding: 0 20px;\n  border: 0;\n  border-radius: 12px;\n  font-size: 1rem !important;\n  cursor: pointer;\n  white-space: nowrap;\n  text-decoration: none !important;\n  font-weight: 400 !important;\n  filter: brightness(",
        "%);\n  \n  &:hover { box-shadow: inset 0 0 0 10em rgba(255, 255, 255, 0.1); }\n  &:focus-visible { outline:none; }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n    border-bottom: 1px solid ",
        ";\n    padding-bottom: 10px;\n    margin-bottom: 10px;\n    display: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    \n    button { border-radius: 0 !important; }\n    > :first-child {\n        border-top-left-radius: 12px !important;\n        border-bottom-left-radius: 12px !important;\n    }\n    > :last-child {\n        border-top-right-radius: 12px !important;\n        border-bottom-right-radius: 12px !important;\n    }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  top: 0;\n  width: 100%;\n  height: 60px;\n  z-index:2;\n  display: flex;\n  padding-left: 20px;\n  padding-top: 10px;\n  border-bottom:  1px solid ",
        ";\n  cursor: pointer;\n  color: ",
        ";\n  background-color: ",
        ";\n\n  &:hover { color: ",
        "; }\n\n  div { line-height: 40px; padding-right: 8px; cursor: pointer; }\n  div:first-child { width: 32px; margin-left: -8px; margin-right: 8px;  }\n  svg { height: 24px; width: 24px; margin-top:8px; margin-bottom:8px; cursor: pointer; }\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n    position: sticky;\n    top:  0;\n    z-index: 10;\n    padding-bottom: 10px;\n    background-color: ",
        ";\n    button {\n    padding-left: 6px;\n    margin: 8px 4px 4px;\n    }\n    svg { margin-left: 8px; margin-right: -4px; }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n    display: flex; padding: 0 20px;\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  height: 36px;\n  word-wrap: unset;\n  display: flex;\n  color: ",
        ";\n  cursor: pointer;\n  padding: 4px 0;\n  box-sizing: border-box;\n  margin: 6px 0;\n\n  &:hover {\n    ",
        ";\n    ",
        ";\n    border-radius: 12px;\n  }\n\n  div:first-child {\n    flex: 0 0 38px;\n    padding: 0 6px;\n  }\n\n  div:nth-child(2) {\n    flex: 0 0 auto;\n    line-height: 28px;\n  }\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  flex: 1 1 auto;\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column-reverse;\n  padding-top: 10px;\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n    color: ",
        ";\n    &:hover {\n        color: ",
        ";\n        svg { color: ",
        " !important; }\n    }\n    cursor: pointer;\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  width: calc(100% + 40px);\n  height: 60px;\n  z-index:2;\n  display: flex;\n  padding-left: 26px;\n  border-bottom:  1px solid ",
        ";\n    margin-left: -20px;\n    margin-right: -20px;\n    padding-top: 10px;\n    padding-bottom: 10px;\n\n  div { line-height: 40px; padding-right: 8px; }\n  svg { height: 24px; width: 24px; margin-top:8px; margin-bottom:8px; }\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  padding:0 20px 20px;\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 40px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  box-sizing: border-box;\n  border-radius: 8px;\n  padding: 4px 16px;\n  font-size: 1rem;\n\n  margin: 4px 0;\n\n  &:focus {\n    outline: none;\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  }\n\n  &::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  display: flex;\n  > :first-child {\n    flex: 1 1 auto;\n  }\n\n  > :last-child {\n    padding-left: 6px;\n    margin-top: 4px;\n  }\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  height: 24px;\n  width: 24px;\n  border: 1px solid ",
        ";\n  box-sizing: border-box;\n  border-radius: 8px;\n  display: inline-block;\n  cursor: pointer;\n\n  svg {\n    margin-top:2px;\n    margin-left:-4px;\n    height: 20px;\n    width: 20px;\n    box-sizing: border-box;\n    display:block;\n  }\n\n  user-select: none;\n  &:focus-visible { outline:none; }\n\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n    padding-right: 10px;\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column-reverse;\n  padding-top: 10px;\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  justify-items: center;\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  display: inline-block;\n  position: relative;\n  width: ",
        "px;\n  height: ",
        "px;\n  padding-top: ",
        "px;\n\n  div {\n    box-sizing: border-box;\n    display: block;\n    position: absolute;\n    width: ",
        "px;\n    height: ",
        "px;\n    margin: ",
        "px;\n    border-width: ",
        "px;\n    border-style: solid;\n   border-radius: 50% !important;\n    animation: ",
        " 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n    border-color: ",
        " transparent transparent transparent;\n\n    div:nth-child(1) {\n      animation-delay: -0.45s;\n    }\n\n    div:nth-child(2) {\n      animation-delay: -0.3s;\n    }\n\n    div:nth-child(3) {\n      animation-delay: -0.15s;\n    }\n  }\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n    display: flex;\n    height: 100%;\n    width: 100%;\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n    padding: 20px;\n    font-size: 1rem;\n    font-weight: 300;\n    line-height: 1.25rem;\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  padding:0 20px 20px;\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  margin-top:10px;\n  height: 10px;\n  width: 10px;\n  background-color: ",
        ";\n  border-radius: 50%;\n  display: ",
        ";\n  margin-left: 6px;\n  flex:0 0 auto;\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  flex: 0 0 24px;\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: 50%;\n  box-sizing: border-box;\n  margin-top:2px;\n  height: 24px;\n  width: 24px;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: bold;\n  display: ",
        ";\n  margin-right: 8px;\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n    svg { margin-left: -8px; }\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\nfont-weight: bold;\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n    color: ",
        ";\n    cursor: pointer;\n    &:hover {\n        color: ",
        " !important;\n        background-color: ",
        " !important;\n        border-radius: 12px;\n    }\n    padding-bottom: 8px;\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n    padding-left: 8px;\n    padding-right: 8px;\n    font-size: 0.875rem;\n    line-height: 1rem;\n    max-height: 3rem;\n    overflow: hidden;\n    color: ",
        " !important;\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  padding:0 20px 20px;\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  display: ",
        ";\n  width: ",
        ";\n  max-width: ",
        ";\n  min-width: 200px;\n  overflow-y: auto;\n  border-right: 1px solid ",
        ";\n  user-select: none;\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  justify-items: center;\n  padding-bottom: 75px;\n  padding-top: 0;\n  box-sizing: border-box;\n  background: none;\n  flex: 1 1 100%;\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  padding: 0 50px;\n  box-sizing: border-box;\n  flex: 1 1 100%;\n  max-width: ",
        "px;\n  @media (min-width: ",
        "px) {\n    padding: 0;\n  }\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  font-weight: 100;\n  text-align: center;\n  word-break: break-word;\n  hyphens: auto;\n  color: ",
        ";\n  font-size: 3rem;\n  margin: 65px 0;\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  text-align: ",
        ";\n  font-size: 1rem;\n  line-height: 1.5rem;\n  hyphens: auto;\n\n  ",
        ";\n\n  font-weight: ",
        ";\n  font-style: ",
        ";\n  letter-spacing: 0.1px;\n\n  a {\n    color: ",
        " !important;\n    font-weight: bold;\n  }\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  padding-top:40px;\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n    padding-top: 16px;\n    display: flex;\n    font-size: 12px;\n    svg {\n        height: 18px;\n        width: 18px;\n        margin-right: -8px;\n        margin-top: 1px;\n    }\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  border-right: ",
        "px solid ",
        ";\n  border-left: ",
        "px solid ",
        ";\n  color: ",
        ";\n  font-style: italic;\n  padding:4px;\n\n  padding-right: ",
        "px;\n  padding-left: ",
        "px;\n  cursor: pointer;\n\n  margin: 0;\n  margin-bottom: 14px;\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject46() {
    var data = _tagged_template_literal([
        "\n  padding: 32px;\n  hyphens: auto;\n  word-wrap: break-word;\n"
    ]);
    _templateObject46 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject47() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: ",
        ";\n"
    ]);
    _templateObject47 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject48() {
    var data = _tagged_template_literal([
        "\n  visibility: ",
        ";\n  display: flex;\n  align-items: flex-end;\n  padding: 32px 12px;\n\n  svg { cursor: pointer;}\n"
    ]);
    _templateObject48 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject49() {
    var data = _tagged_template_literal([
        "\n  background-color: ",
        ";\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  letter-spacing: 0.1px;\n  text-decoration: none;\n  color: ",
        ";\n  width: fit-content;\n  display: flex;\n  flex-direction:  ",
        ";\n  \n  border: 1px solid ",
        ";\n  margin-top: 20px;\n  border-radius: 12px;\n\n  div.message-date {\n    color: ",
        ";\n    font-weight: bold;\n  }\n\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n"
    ]);
    _templateObject49 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject50() {
    var data = _tagged_template_literal([
        "\n  display: ",
        ";  \n  font-size: 12px;\n  font-weight: bold;\n"
    ]);
    _templateObject50 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject51() {
    var data = _tagged_template_literal([
        "\n  font-weight: bold;\n\n    display: flex;\n\n\n  svg {\n    height: 20px;\n    width:  20px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject51 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject52() {
    var data = _tagged_template_literal([
        "\n  padding-bottom: 20px;\n\n"
    ]);
    _templateObject52 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject53() {
    var data = _tagged_template_literal([
        "\n  word-break: break-word;\n  hyphens: auto;\n"
    ]);
    _templateObject53 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject54() {
    var data = _tagged_template_literal([
        "\n    line-height: 40px;\n    padding-top: 7px;\n    cursor: pointer;\n"
    ]);
    _templateObject54 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject55() {
    var data = _tagged_template_literal([
        "\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n    justify-items: center;\n    text-align: center;\n    height: 26px;\n    width: 26px;\n    background-color: ",
        ";\n    color: ",
        ";\n    font-family: Georgia;\n    font-size: 18px;\n    font-weight: bold;\n    padding-right: 0 !important;\n    margin-right: 7px;\n    border: 1px solid ",
        ";\n"
    ]);
    _templateObject55 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject56() {
    var data = _tagged_template_literal([
        "\n    color: ",
        ";\n    &:hover { \n        color: ",
        ";\n        svg { color: ",
        " !important; }\n    }\n    cursor: pointer;\n"
    ]);
    _templateObject56 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject57() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 60px;\n  z-index:2;\n  display: flex;\n  padding-left: 20px;\n  padding-top: 10px;\n  border-bottom:  1px solid ",
        ";\n    \n  div { line-height: 40px; padding-right: 8px; }\n  svg { height: 24px; width: 24px; margin-top:8px; margin-bottom:8px; }\n"
    ]);
    _templateObject57 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject58() {
    var data = _tagged_template_literal([
        "\n  height: 100%;\n  width: 100%;\n"
    ]);
    _templateObject58 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject59() {
    var data = _tagged_template_literal([
        "\n    box-sizing: border-box;\n    overflow-y: auto;\n    height: calc(100% - ",
        "px - ",
        "px);\n    border-top: 1px solid ",
        ";\n    border-bottom: 1px solid ",
        ";\n    padding: 20px;\n"
    ]);
    _templateObject59 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject60() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  box-sizing: border-box;\n  border-radius: 8px;\n  padding: 16px;\n  font-size: 1rem;\n  margin: 0;\n  height: 56px;\n  font-family: 'Roboto', sans-serif;\n  resize: none;\n  font-weight: 300;\n\n  &:focus {\n    outline: none;\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  }\n\n  &::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject60 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject61() {
    var data = _tagged_template_literal([
        "\n  flex: 1 1 auto;\n  overflow: hidden;\n  line-height: 40px;\n  font-size: 0.875rem;\n  padding: 0 20px;\n"
    ]);
    _templateObject61 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject62() {
    var data = _tagged_template_literal([
        "\n  height: 40px;\n  display: flex;\n  width: 100%;\n  background-color: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject62 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject63() {
    var data = _tagged_template_literal([
        "\n  flex: 0 0 32px;\n  svg { height: 24px; width: 24px; margin-top: 8px; }\n  padding-right: 8px;\n  cursor: pointer;\n"
    ]);
    _templateObject63 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject64() {
    var data = _tagged_template_literal([
        "\n  height:",
        "px;\n"
    ]);
    _templateObject64 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject65() {
    var data = _tagged_template_literal([
        "\n  flex: 0 0 auto;\n  padding-left: 6px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  height: 100%;\n"
    ]);
    _templateObject65 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject66() {
    var data = _tagged_template_literal([
        "\n  flex : 1 1 auto;\n\n  textarea {\n    margin:0;\n    height:",
        "px;\n  }\n"
    ]);
    _templateObject66 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject67() {
    var data = _tagged_template_literal([
        "\n  height:",
        "px;\n  display: flex;\n  flex-direction: row;\n  padding:",
        "px;\n"
    ]);
    _templateObject67 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject68() {
    var data = _tagged_template_literal([
        "\n  z-index: 10;\n  top: 10px;\n  position: absolute;\n  right: 10px;\n"
    ]);
    _templateObject68 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject69() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n"
    ]);
    _templateObject69 = function _templateObject() {
        return data;
    };
    return data;
}
import { useState } from "react";
import styled, { keyframes, useTheme } from "styled-components";
import { jsx } from "react/jsx-runtime";
var Avatar_default = function(props) {
    var avatarUrl = props.avatarUrl, _props_color = props.color, color = _props_color === void 0 ? "primary" : _props_color, _props_size = props.size, size = _props_size === void 0 ? 60 : _props_size, grayscale = props.grayscale, onClick = props.onClick, _props_isDataUrl = props.isDataUrl, isDataUrl = _props_isDataUrl === void 0 ? false : _props_isDataUrl;
    var _useState = _sliced_to_array(useState(false), 2), error = _useState[0], setError = _useState[1];
    var theme = useTheme();
    var fillColor = grayscale ? "tertiary" : color;
    var fill = theme.colors[fillColor].trim().replace("#", "%23");
    if (error || !avatarUrl) return /* @__PURE__ */ jsx(Shimmer, {
        size: size
    });
    var url = isDataUrl ? avatarUrl : "".concat(avatarUrl, "&color=white&fill=").concat(fill);
    var onImageClick = function() {
        if (onClick) onClick();
    };
    return /* @__PURE__ */ jsx(Image, {
        onClick: onImageClick,
        onError: function() {
            return setError(true);
        },
        grayscale: grayscale === true,
        height: size,
        width: size,
        src: url,
        alt: "",
        clickable: !!onClick
    });
};
var Image = styled.img(_templateObject(), function(p) {
    return p.grayscale ? "filter: grayscale(110%);" : "";
}, function(p) {
    return p.clickable ? "cursor: pointer;" : "";
});
var shimmering = keyframes(_templateObject1());
var Shimmer = styled.div(_templateObject2(), function(p) {
    return p.size;
}, function(p) {
    return p.size;
}, function(p) {
    return p.theme.colors.defaultSupport;
}, shimmering, function(p) {
    return p.theme.colors.defaultSupport;
}, function(p) {
    return p.theme.colors.defaultSupport;
}, function(p) {
    return p.theme.colors.defaultInverse;
}, function(p) {
    return p.theme.colors.defaultSupport;
});
// src/icons/index.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var CheckMark = function(param) {
    var color = param.color, _param_height = param.height, height = _param_height === void 0 ? 48 : _param_height;
    return /* @__PURE__ */ jsx2("svg", {
        viewBox: "0 0 24 24",
        height: height,
        width: height,
        focusable: "false",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsx2("path", {
            d: "M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z",
            fill: color
        })
    });
};
var Close = function(param) {
    var color = param.color, _param_height = param.height, height = _param_height === void 0 ? 48 : _param_height;
    return /* @__PURE__ */ jsxs("svg", {
        viewBox: "0 0 24 24",
        height: height,
        width: height,
        focusable: "false",
        fill: color,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ jsx2("path", {
                fill: "none",
                d: "M0 0h24v24H0V0z"
            }),
            /* @__PURE__ */ jsx2("path", {
                d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
            })
        ]
    });
};
var Left = function(param) {
    var color = param.color, _param_height = param.height, height = _param_height === void 0 ? 48 : _param_height;
    return /* @__PURE__ */ jsx2("svg", {
        viewBox: "0 0 512 512",
        height: height,
        width: height,
        fill: color,
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsx2("path", {
            fill: "none",
            stroke: color,
            strokeLinecap: "square",
            strokeMiterlimit: "10",
            strokeWidth: "48",
            d: "M328 112L184 256l144 144"
        })
    });
};
var Send = function(props) {
    var color = props.color, _props_height = props.height, height = _props_height === void 0 ? 48 : _props_height, onClick = props.onClick;
    var click = function() {
        if (onClick) onClick();
    };
    return /* @__PURE__ */ jsx2("svg", {
        onClick: function() {
            return click();
        },
        viewBox: "0 0 16 16",
        height: height,
        width: height,
        fill: color,
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsx2("path", {
            d: "M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07Zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493Z"
        })
    });
};
var Copy = function(param) {
    var color = param.color, _param_height = param.height, height = _param_height === void 0 ? 48 : _param_height, onClick = param.onClick;
    return /* @__PURE__ */ jsxs("svg", {
        onClick: function() {
            return onClick();
        },
        viewBox: "0 0 24 24",
        height: height,
        width: height,
        fill: color,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ jsx2("path", {
                fill: "none",
                d: "M0 0h24v24H0V0z"
            }),
            /* @__PURE__ */ jsx2("path", {
                d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
            })
        ]
    });
};
var Reply = function(param) {
    var color = param.color, _param_height = param.height, height = _param_height === void 0 ? 48 : _param_height, onClick = param.onClick;
    return /* @__PURE__ */ jsx2("svg", {
        onClick: function() {
            return onClick();
        },
        viewBox: "0 0 16 16",
        height: height,
        width: height,
        fill: color,
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsx2("path", {
            d: "M6.598 5.013a.144.144 0 0 1 .202.134V6.3a.5.5 0 0 0 .5.5c.667 0 2.013.005 3.3.822.984.624 1.99 1.76 2.595 3.876-1.02-.983-2.185-1.516-3.205-1.799a8.74 8.74 0 0 0-1.921-.306 7.404 7.404 0 0 0-.798.008h-.013l-.005.001h-.001L7.3 9.9l-.05-.498a.5.5 0 0 0-.45.498v1.153c0 .108-.11.176-.202.134L2.614 8.254a.503.503 0 0 0-.042-.028.147.147 0 0 1 0-.252.499.499 0 0 0 .042-.028l3.984-2.933zM7.8 10.386c.068 0 .143.003.223.006.434.02 1.034.086 1.7.271 1.326.368 2.896 1.202 3.94 3.08a.5.5 0 0 0 .933-.305c-.464-3.71-1.886-5.662-3.46-6.66-1.245-.79-2.527-.942-3.336-.971v-.66a1.144 1.144 0 0 0-1.767-.96l-3.994 2.94a1.147 1.147 0 0 0 0 1.946l3.994 2.94a1.144 1.144 0 0 0 1.767-.96v-.667z"
        })
    });
};
var AddGroup = function(param) {
    var color = param.color, _param_height = param.height, height = _param_height === void 0 ? 48 : _param_height, onClick = param.onClick;
    var click = function() {
        if (onClick) onClick();
    };
    return /* @__PURE__ */ jsxs("svg", {
        onClick: function() {
            return click();
        },
        viewBox: "0 0 24 24",
        height: height,
        width: height,
        fill: color,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ jsx2("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /* @__PURE__ */ jsx2("path", {
                d: "M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z"
            })
        ]
    });
};
var UserGroup = function(param) {
    var color = param.color, _param_height = param.height, height = _param_height === void 0 ? 48 : _param_height;
    return /* @__PURE__ */ jsxs("svg", {
        viewBox: "0 0 24 24",
        height: height,
        width: height,
        fill: color,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ jsx2("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /* @__PURE__ */ jsx2("path", {
                d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
            })
        ]
    });
};
var Trash = function(param) {
    var color = param.color, _param_height = param.height, height = _param_height === void 0 ? 48 : _param_height, onClick = param.onClick;
    var click = function() {
        if (onClick) onClick();
    };
    return /* @__PURE__ */ jsxs("svg", {
        onClick: function() {
            return click();
        },
        viewBox: "0 0 512 512",
        height: height,
        width: height,
        fill: color,
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ jsx2("path", {
                fill: "none",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "m112 112 20 320c.95 18.49 14.4 32 32 32h184c17.67 0 30.87-13.51 32-32l20-320"
            }),
            /* @__PURE__ */ jsx2("path", {
                stroke: color,
                strokeLinecap: "round",
                strokeMiterlimit: "10",
                strokeWidth: "32",
                d: "M80 112h352"
            }),
            /* @__PURE__ */ jsx2("path", {
                fill: "none",
                stroke: color,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "32",
                d: "M192 112V72h0a23.93 23.93 0 0 1 24-24h80a23.93 23.93 0 0 1 24 24h0v40m-64 64v224m-72-224 8 224m136-224-8 224"
            })
        ]
    });
};
var Save = function(param) {
    var color = param.color, _param_height = param.height, height = _param_height === void 0 ? 48 : _param_height, onClick = param.onClick;
    var click = function() {
        if (onClick) onClick();
    };
    return /* @__PURE__ */ jsx2("svg", {
        viewBox: "0 0 24 24",
        onClick: function() {
            return click();
        },
        height: height,
        width: height,
        fill: color,
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ jsx2("path", {
            d: "M3 5.75A2.75 2.75 0 0 1 5.75 3h9.96c.87 0 1.7.34 2.3.95L20.05 6c.6.6.95 1.43.95 2.3v9.96A2.75 2.75 0 0 1 18.25 21H5.75A2.75 2.75 0 0 1 3 18.25V5.75zM5.75 4.5c-.69 0-1.25.56-1.25 1.25v12.5c0 .69.56 1.25 1.25 1.25H6v-5.25C6 13.01 7 12 8.25 12h7.5c1.24 0 2.25 1 2.25 2.25v5.25h.25c.69 0 1.25-.56 1.25-1.25V8.29c0-.47-.18-.91-.51-1.24L16.95 5c-.26-.26-.6-.43-.95-.49v2.73c0 1.24-1 2.25-2.25 2.25h-4.5C8.01 9.5 7 8.5 7 7.25V4.5H5.75zm10.75 15v-5.25a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0-.75.75v5.25h9zm-8-15v2.75c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75V4.5h-6z"
        })
    });
};
// src/components/Shared/SnackBar.tsx
import { useEffect, useState as useState2 } from "react";
import { createPortal } from "react-dom";
import styled2, { useTheme as useTheme2 } from "styled-components";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var SnackBar_default = function(props) {
    var closable = props.closable, message = props.message, type = props.type, show = props.show, onClose = props.onClose;
    var _useState2 = _sliced_to_array(useState2(show), 2), transition = _useState2[0], setTransition = _useState2[1];
    var color = getColor(type);
    useEffect(function() {
        if (!show) return;
        setTimeout(function() {
            setTransition(true);
        }, 10);
        setTimeout(function() {
            setTransition(false);
            onClose();
        }, 3500);
    }, [
        show
    ]);
    return createPortal(/* @__PURE__ */ jsx3(Container, {
        show: show,
        transition: transition,
        children: /* @__PURE__ */ jsxs2(Message, {
            type: type,
            children: [
                /* @__PURE__ */ jsx3(Center, {
                    children: message
                }),
                closable !== false && /* @__PURE__ */ jsx3(CloseButton, {
                    onClick: function() {
                        return setTransition(false);
                    },
                    children: /* @__PURE__ */ jsx3(Close, {
                        color: color
                    })
                })
            ]
        })
    }), document.body);
};
var Container = styled2.div(_templateObject3(), function(p) {
    return p.transition ? 0 : -80;
}, function(p) {
    return p.show ? "flex" : "none";
});
var Message = styled2.div(_templateObject4(), function(p) {
    return p.theme.screens.large - 40;
}, function(p) {
    return getBackgroundColor(p.type);
}, function(p) {
    return getColor(p.type);
});
var CloseButton = styled2.div(_templateObject5());
var getBackgroundColor = function(type) {
    var theme = useTheme2();
    if (type === "error") return theme.colors.error;
    return theme.colors.secondary;
};
var getColor = function(type) {
    var theme = useTheme2();
    if (type === "error") return theme.colors.defaultInverse;
    return theme.colors.defaultInverse;
};
var Center = styled2.div(_templateObject6());
// src/components/Chat.tsx
import { useFetchContext } from "@bbcs/bbcs-fetch";
// src/context/ChatContext.ts
import React from "react";
var ChatContext_default = React.createContext(void 0);
// src/hooks/useInitialMessage.ts
import { useGetAsync } from "@bbcs/bbcs-fetch";
import { useEffect as useEffect2, useState as useState3 } from "react";
var getInitial = function(messageId, initialChannelId) {
    if (initialChannelId) return initialChannelId;
    if (messageId) return null;
    return void 0;
};
var useInitialMessage_default = function(messageId, initialChannelId) {
    var _useState3 = _sliced_to_array(useState3(getInitial(messageId, initialChannelId)), 2), channelId = _useState3[0], setChannelId = _useState3[1];
    var get = useGetAsync();
    useEffect2(function() {
        if (initialChannelId || !messageId) return;
        get("/user/messages/".concat(messageId, "/channel")).then(function(response) {
            var _response_body;
            var _response_body_id;
            return setChannelId((_response_body_id = response === null || response === void 0 ? void 0 : (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.id) !== null && _response_body_id !== void 0 ? _response_body_id : void 0);
        });
    }, [
        initialChannelId,
        messageId
    ]);
    return channelId;
};
// src/components/ChatPanel.tsx
import { useState as useState26 } from "react";
import styled42 from "styled-components";
// src/components/ChannelsColumn/index.tsx
import styled26 from "styled-components";
// src/types/ViewMode.ts
var ViewMode = /* @__PURE__ */ function(ViewMode2) {
    ViewMode2["Channel"] = "Channel";
    ViewMode2["Messages"] = "Messages";
    ViewMode2["Both"] = "Both";
    return ViewMode2;
}(ViewMode || {});
var ViewMode_default = ViewMode;
// src/types/ChannelTool.ts
var ChannelTool = /* @__PURE__ */ function(ChannelTool2) {
    ChannelTool2["ChannelView"] = "ChannelView";
    ChannelTool2["ChannelInfo"] = "ChannelInfo";
    ChannelTool2["CreateGroup"] = "CreateGroup";
    return ChannelTool2;
}(ChannelTool || {});
var ChannelTool_default = ChannelTool;
// src/types/ChannelType.ts
var ChannelType = /* @__PURE__ */ function(ChannelType2) {
    ChannelType2["Personal"] = "Personal";
    ChannelType2["Public"] = "Public";
    ChannelType2["Private"] = "Private";
    return ChannelType2;
}(ChannelType || {});
var ChannelType_default = ChannelType;
// src/context/useChatContext.ts
import { useContext } from "react";
var useChatContext_default = function() {
    return useContext(ChatContext_default);
};
// src/context/useViewContext.tsx
import { useContext as useContext2 } from "react";
// src/context/ViewContext.ts
import React2 from "react";
var ViewContext_default = React2.createContext(void 0);
// src/context/useViewContext.tsx
var useViewContext_default = function() {
    return useContext2(ViewContext_default);
};
// src/components/ChannelsColumn/GroupInfo/index.tsx
import styled10 from "styled-components";
// src/hooks/useLanguage.ts
var useLanguage_default = function() {
    var language = useChatContext_default().language;
    return language;
};
// src/localization.ts
var localization_default = {
    nl: {
        title: "Jouw berichten",
        searchInMessages: "Zoeken in berichten",
        search: "Zoek",
        nameChangeMessage: "Gebruiker '@old_name' heeft zijn naam veranderd naar  '@new_name'.",
        mentorChangeLeaveMessage: "Beste mentor, ik ben niet langer je student, maar ben de cursus '@course' gaan volgen bij een andere mentor.  Mijn nieuwe mentor zal ook de lessen nakijken die eventueel nog niet waren nagekeken.",
        mentorChangeEnter: "Beste mentor, ik ben nu begonnen aan de cursus '@course', ik ben deze cursus al eerder gestart bij een andere mentor. Mochten er nog lessen niet nagekeken zijn, zou die je dan willen nakijken?",
        studentEnrollment: "Ik ben nu begonnen aan de cursus '@course'.",
        studentLessonSubmission: "Beste mentor, @url op les '@lesson' van cursus '@course'.",
        studentLessonSubmissionLabel: "hier zijn mijn antwoorden",
        mentorLessonSubmissionReview: "Beste student, @url '@lesson' van cursus '@course'.  Eventuele reacties op je antwoorden vind je in de berichtjes hierna.",
        mentorLessonSubmissionReviewLabel: "hierbij de nagekeken les",
        question: "Vraag:",
        answer: "Gegeven antwoord:",
        correct: "Correcte antwoord:",
        review: "Reactie mentor",
        true: "Juist",
        false: "Onjuist",
        send: "Verstuur",
        dashboard: "Dashboard",
        noChannel: "Aangezien je nog geen cursus met een mentor hebt gevolgd, zijn er nog geen verstuurde berichten om weer te geven.",
        groupName: "Groepsnaam",
        cancel: "Annuleren",
        close: "Sluiten",
        channel: "Groep: ",
        groupSaved: "Chat groep is opgeslagen",
        groupSaveFailed: "Er is een fout opgetreden tijdens het opslaan van de instellingen van de chatgroep. Probeert u het opnieuw of neem contact op met de ondersteuning voor verdere hulp.",
        groupDelete: "Bent u zeker dat u deze groep wilt verwijderen? Hiermee worden ook alle bijbehorende berichten permanent verwijderd.",
        delete: "Verwijderen",
        groupDeleted: "De groep en alle berichten in de groep zijn verwijderd.",
        groupDeletionFailed: "Er is een fout opgetreden tijdens het verwijderen van de chatgroep. Probeert u het opnieuw of neem contact op met de ondersteuning voor verdere hulp."
    }
};
// src/components/Shared/Button.tsx
import styled3 from "styled-components";
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var Button_default = function(props) {
    var href = props.href, label = props.label, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_color = props.color, color = _props_color === void 0 ? "primary" : _props_color, onClick = props.onClick, icon = props.icon, hidden = props.hidden;
    var navigate = useChatContext_default().navigate;
    var onButtonClick = function() {
        if (onClick) onClick();
        else if (href) navigate(href);
    };
    if (hidden === true) return null;
    return /* @__PURE__ */ jsx4(ButtonBase, {
        onClick: function() {
            return onButtonClick();
        },
        disabled: disabled,
        color: color,
        type: "button",
        children: /* @__PURE__ */ jsxs3(Content, {
            children: [
                label,
                icon
            ]
        })
    });
};
var Content = styled3.div(_templateObject7());
var ButtonBase = styled3.button(_templateObject8(), function(p) {
    return p.theme.colors[p.color];
}, function(p) {
    return p.theme.colors["".concat(p.color, "Inverse")];
}, function(p) {
    return p.disabled ? 60 : 100;
});
// src/components/ChannelsColumn/ChannelsView/Separator.tsx
import styled4 from "styled-components";
var Separator_default = styled4.div(_templateObject9(), function(p) {
    return p.theme.colors.tertiary;
}, function(p) {
    return p.show ? "block" : "none";
});
// src/components/Shared/ButtonGroup.tsx
import styled5 from "styled-components";
var ButtonGroup_default = styled5.div(_templateObject10());
// src/components/ChannelsColumn/ChannelsView/Toolbar.tsx
import styled7 from "styled-components";
// src/components/ChannelsColumn/ChannelsView/BackToApp.tsx
import styled6, { useTheme as useTheme3 } from "styled-components";
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var BackToApp_default = function(props) {
    var show = props.show;
    var language = useLanguage_default();
    var navigate = useChatContext_default().navigate;
    var theme = useTheme3();
    var back = function() {
        navigate("/user/dashboard");
    };
    if (!show) return null;
    return /* @__PURE__ */ jsxs4(BackBar, {
        onClick: back,
        children: [
            /* @__PURE__ */ jsx5("div", {
                children: /* @__PURE__ */ jsx5(Left, {
                    color: theme.colors.primary,
                    height: 24
                })
            }),
            /* @__PURE__ */ jsx5("div", {
                children: localization_default[language].dashboard
            })
        ]
    });
};
var BackBar = styled6.div(_templateObject11(), function(p) {
    return p.theme.colors.defaultSupport;
}, function(p) {
    return p.theme.colors.primary;
}, function(p) {
    return p.theme.colors.primaryInverse;
}, function(p) {
    return p.theme.colors.secondary;
});
// src/components/ChannelsColumn/ChannelsView/Toolbar.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var Toolbar_default = function(props) {
    var viewMode = useViewContext_default().viewMode;
    var children = props.children, showBackToApp = props.showBackToApp;
    return /* @__PURE__ */ jsxs5(Tools, {
        showBackToDashboard: showBackToApp,
        children: [
            /* @__PURE__ */ jsx6(BackToApp_default, {
                show: showBackToApp && viewMode === ViewMode_default.Channel
            }),
            /* @__PURE__ */ jsx6(Div, {
                children: children
            })
        ]
    });
};
var Tools = styled7.div(_templateObject12(), function(p) {
    return p.theme.colors.defaultInverse;
});
var Div = styled7.div(_templateObject13());
// src/components/ChannelsColumn/ChannelsView/Styled.tsx
import styled8 from "styled-components";
var Container2 = styled8.div(_templateObject14(), function(p) {
    return p.selected ? p.theme.colors.primary : p.theme.colors.tertiary;
}, function(p) {
    return p.disabled ? "" : "color: ".concat(p.theme.colors.default);
}, function(p) {
    return p.disabled ? "" : "background-color: ".concat(p.theme.colors.defaultSupport);
});
// src/components/Shared/Spacer.tsx
import styled9 from "styled-components";
var Spacer_default = styled9.div(_templateObject15());
// src/components/ChannelsColumn/GroupInfo/ReceiverView.tsx
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var ReceiverView_default = function(props) {
    var receiver = props.receiver;
    return /* @__PURE__ */ jsxs6(Container2, {
        selected: false,
        disabled: false,
        children: [
            /* @__PURE__ */ jsx7("div", {
                children: /* @__PURE__ */ jsx7(Avatar_default, {
                    grayscale: !receiver.userActive,
                    size: 28,
                    avatarUrl: receiver.userAvatarUrl
                })
            }),
            /* @__PURE__ */ jsx7("div", {
                children: receiver.userName
            }),
            /* @__PURE__ */ jsx7(Spacer_default, {})
        ]
    });
};
// src/components/ChannelsColumn/GroupInfo/index.tsx
import { Fragment, jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var GroupInfo_default = function() {
    var _useViewContext_default = useViewContext_default(), selectedChannel = _useViewContext_default.selectedChannel, onCloseChannelTool = _useViewContext_default.onCloseChannelTool, channels = _useViewContext_default.channels;
    var language = useLanguage_default();
    var channel = channels.find(function(c) {
        return c.id === (selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.id);
    });
    var _channel_receivers;
    var receivers = (_channel_receivers = channel === null || channel === void 0 ? void 0 : channel.receivers) !== null && _channel_receivers !== void 0 ? _channel_receivers : [];
    var terms = localization_default[language];
    return /* @__PURE__ */ jsxs7(Fragment, {
        children: [
            /* @__PURE__ */ jsx8(Toolbar_default, {
                showBackToApp: false,
                children: /* @__PURE__ */ jsx8(Bar, {
                    children: /* @__PURE__ */ jsxs7(Div2, {
                        children: [
                            terms.channel,
                            " ",
                            channel === null || channel === void 0 ? void 0 : channel.name
                        ]
                    })
                })
            }),
            /* @__PURE__ */ jsxs7(Container3, {
                children: [
                    receivers.map(function(r) {
                        return /* @__PURE__ */ jsx8(ReceiverView_default, {
                            receiver: r
                        }, r.userId);
                    }),
                    /* @__PURE__ */ jsx8(Separator_default, {
                        show: true
                    }),
                    /* @__PURE__ */ jsx8(Close2, {
                        children: /* @__PURE__ */ jsx8(ButtonGroup_default, {
                            children: /* @__PURE__ */ jsx8(Button_default, {
                                color: "primary",
                                onClick: onCloseChannelTool,
                                label: terms.close
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var Close2 = styled10.div(_templateObject16());
var Div2 = styled10.div(_templateObject17(), function(p) {
    return p.theme.colors.primary;
}, function(p) {
    return p.theme.colors.secondary;
}, function(p) {
    return p.theme.colors.secondary;
});
var Bar = styled10.div(_templateObject18(), function(p) {
    return p.theme.colors.defaultSupport;
});
var Container3 = styled10.div(_templateObject19());
// src/components/ChannelsColumn/GroupChatDialog/index.tsx
import styled20, { useTheme as useTheme7 } from "styled-components";
import { useState as useState9 } from "react";
// src/hooks/useStudents.ts
import { useGetAsync as useGetAsync2 } from "@bbcs/bbcs-fetch";
import { useEffect as useEffect3, useState as useState4 } from "react";
var useStudents_default = function(mentorId) {
    var get = useGetAsync2();
    var _useState4 = _sliced_to_array(useState4(), 2), students = _useState4[0], setStudents = _useState4[1];
    useEffect3(function() {
        get("/mentor/students").then(function(result) {
            if (!result.ok) setStudents(null);
            else setStudents(result.body);
        });
    }, [
        mentorId
    ]);
    return students;
};
// src/components/Shared/TextInput.tsx
import styled11 from "styled-components";
import { jsx as jsx9 } from "react/jsx-runtime";
var TextInput_default = function(props) {
    var property = props.property, placeholder = props.placeholder, value = props.value, onChange = props.onChange, hasError = props.hasError;
    return /* @__PURE__ */ jsx9("div", {
        children: /* @__PURE__ */ jsx9(Input, {
            onChange: function(event) {
                return onChange(event.target.value);
            },
            placeholder: placeholder,
            value: value !== null && value !== void 0 ? value : "",
            type: "text",
            error: hasError === true,
            name: property
        })
    });
};
var Input = styled11.input(_templateObject20(), function(p) {
    return p.error ? p.theme.colors.error : p.theme.colors.tertiary;
}, function(p) {
    return p.error ? p.theme.colors.error : p.theme.colors.default;
}, function(p) {
    return p.theme.colors.primary;
}, function(p) {
    return p.theme.colors.primary;
}, function(p) {
    return p.theme.colors.tertiary;
});
// src/components/ChannelsColumn/ChannelsView/Input.tsx
import styled12 from "styled-components";
import { jsx as jsx10 } from "react/jsx-runtime";
var Input_default = function(props) {
    var value = props.value, onChange = props.onChange, placeholder = props.placeholder, hasError = props.hasError;
    return /* @__PURE__ */ jsx10(Container4, {
        children: /* @__PURE__ */ jsx10(TextInput_default, {
            hasError: hasError,
            property: "property",
            onChange: onChange,
            value: value,
            placeholder: placeholder
        })
    });
};
var Container4 = styled12.div(_templateObject21());
// src/components/ChannelsColumn/GroupChatDialog/StudentSelector.tsx
import styled14 from "styled-components";
// src/components/Shared/CheckBox.tsx
import styled13, { useTheme as useTheme4 } from "styled-components";
import { useState as useState5 } from "react";
import { jsx as jsx11 } from "react/jsx-runtime";
var CheckBox = function(props) {
    var selected = props.selected, onChange = props.onChange;
    var _useState5 = _sliced_to_array(useState5(false), 2), focus = _useState5[0], setFocus = _useState5[1];
    var theme = useTheme4();
    var color = selected ? theme.colors.primary : "transparent";
    var onClick = function() {
        onChange(!selected);
    };
    return /* @__PURE__ */ jsx11(Base, {
        onClick: function() {
            return onClick();
        },
        onFocus: function() {
            return setFocus(true);
        },
        onBlur: function() {
            return setFocus(false);
        },
        focus: focus,
        children: /* @__PURE__ */ jsx11(CheckMark, {
            color: color,
            height: 28
        })
    });
};
var Base = styled13.div(_templateObject22(), function(p) {
    return p.focus ? p.theme.colors.primary : p.theme.colors.tertiary;
});
var CheckBox_default = CheckBox;
// src/components/ChannelsColumn/GroupChatDialog/StudentSelector.tsx
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var StudentSelector_default = function(props) {
    var student = props.student, active = props.active, selected = props.selected, onSelect = props.onSelect;
    var onChange = function(value) {
        return onSelect(student.studentId, value);
    };
    return /* @__PURE__ */ jsxs8(Container2, {
        selected: false,
        disabled: false,
        children: [
            /* @__PURE__ */ jsx12("div", {
                children: /* @__PURE__ */ jsx12(Avatar_default, {
                    grayscale: !active,
                    size: 28,
                    avatarUrl: student.studentAvatarUrl
                })
            }),
            /* @__PURE__ */ jsx12("div", {
                children: student.studentName
            }),
            /* @__PURE__ */ jsx12(Spacer_default, {}),
            /* @__PURE__ */ jsx12(CheckBoxContainer, {
                children: /* @__PURE__ */ jsx12(CheckBox_default, {
                    onChange: onChange,
                    selected: selected
                })
            })
        ]
    });
};
var CheckBoxContainer = styled14.div(_templateObject23());
// src/components/ChannelsColumn/GroupChatDialog/useGroupChannel.ts
import { useEffect as useEffect4, useState as useState6 } from "react";
var newChannel = {
    id: -1,
    name: "",
    students: []
};
var useGroupChannel_default = function(channel, channelTool) {
    var _useState6 = _sliced_to_array(useState6(newChannel), 2), groupChannel = _useState6[0], setGroupChannel = _useState6[1];
    var user = useChatContext_default().user;
    useEffect4(function() {
        if (!(channel === null || channel === void 0 ? void 0 : channel.id) || channel.id < 1) return setGroupChannel(newChannel);
        if (channelTool !== ChannelTool_default.ChannelInfo) return setGroupChannel(newChannel);
        var students = channel.receivers.filter(function(r) {
            return r.userId !== user.id;
        }).map(function(r) {
            return r.userId;
        });
        return setGroupChannel(_object_spread_props(_object_spread({}, channel), {
            students: students
        }));
    }, [
        channel,
        channelTool
    ]);
    var addStudent = function(studentId) {
        var students = _to_consumable_array(groupChannel.students);
        if (!students.includes(studentId)) students.push(studentId);
        setGroupChannel(_object_spread_props(_object_spread({}, groupChannel), {
            students: students
        }));
    };
    var removeStudent = function(studentId) {
        var students = _to_consumable_array(groupChannel.students);
        if (students.includes(studentId)) students = students.filter(function(id) {
            return id !== studentId;
        });
        setGroupChannel(_object_spread_props(_object_spread({}, groupChannel), {
            students: students
        }));
    };
    var setName = function(name) {
        setGroupChannel(_object_spread_props(_object_spread({}, groupChannel), {
            name: name
        }));
    };
    return {
        groupChannel: groupChannel,
        addStudent: addStudent,
        removeStudent: removeStudent,
        setName: setName
    };
};
// src/components/ChannelsColumn/GroupChatDialog/usePostGroupChannel.ts
import { usePost, usePut } from "@bbcs/bbcs-fetch";
import { useState as useState7 } from "react";
// src/util/isEmpty.ts
var isEmpty_default = function(value) {
    return !(value && value !== "");
};
// src/components/ChannelsColumn/GroupChatDialog/usePostGroupChannel.ts
var validate = function(channel, channels) {
    if (isEmpty_default(channel === null || channel === void 0 ? void 0 : channel.name) || (channel === null || channel === void 0 ? void 0 : channel.name.length) < 3) return {
        valid: false,
        msg: "invalid-name"
    };
    var existing = channels.filter(function(c) {
        return c.name.toLowerCase().trim() === channel.name.toLowerCase().trim();
    });
    if (existing.length === 0) return {
        valid: true,
        msg: void 0
    };
    if (existing.length > 1) return {
        valid: false,
        msg: "name-existing"
    };
    if (existing[0].id === channel.id) return {
        valid: true,
        msg: void 0
    };
    return {
        valid: false,
        msg: "name-existing"
    };
};
var usePostGroupChannel_default = function() {
    var _useState7 = _sliced_to_array(useState7("none"), 2), state = _useState7[0], setState = _useState7[1];
    var _useState71 = _sliced_to_array(useState7(), 2), error = _useState71[0], setError = _useState71[1];
    var post = usePost();
    var put = usePut();
    var onSaveChannel = function() {
        var _ref = _async_to_generator(function(channel, channels) {
            var _validate, valid, msg, body, response, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _validate = validate(channel, channels), valid = _validate.valid, msg = _validate.msg;
                        setError(msg);
                        if (!valid) return [
                            2,
                            setState("invalid")
                        ];
                        setState("pending");
                        body = {
                            name: channel.name,
                            students: channel.students
                        };
                        if (!(channel.id > 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            put("/mentor/channels/".concat(channel.id), body)
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            post("/mentor/channels", body)
                        ];
                    case 3:
                        _tmp = _state.sent();
                        _state.label = 4;
                    case 4:
                        response = _tmp;
                        if (response.ok) return [
                            2,
                            setState("success")
                        ];
                        return [
                            2,
                            setState("failed")
                        ];
                }
            });
        });
        return function onSaveChannel(channel, channels) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        state: state,
        onSaveChannel: onSaveChannel,
        error: error
    };
};
// src/components/ChannelsColumn/GroupChatDialog/Messages.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var GroupSaved = function(param) {
    var show = param.show, onClose = param.onClose;
    var language = useLanguage_default();
    var message = localization_default[language].groupSaved;
    if (!show) return null;
    return /* @__PURE__ */ jsx13(SnackBar_default, {
        show: show,
        type: "success",
        message: message,
        closable: true,
        onClose: onClose
    });
};
var GroupSavingFailed = function(param) {
    var show = param.show, onClose = param.onClose;
    var language = useLanguage_default();
    var message = localization_default[language].groupSaved;
    if (!show) return null;
    return /* @__PURE__ */ jsx13(SnackBar_default, {
        show: show,
        type: "error",
        message: message,
        closable: true,
        onClose: onClose
    });
};
var GroupDeleted = function(param) {
    var show = param.show, onClose = param.onClose;
    var language = useLanguage_default();
    var message = localization_default[language].groupDeleted;
    if (!show) return null;
    return /* @__PURE__ */ jsx13(SnackBar_default, {
        show: show,
        type: "success",
        message: message,
        closable: true,
        onClose: onClose
    });
};
var GroupDeletionFailed = function(param) {
    var show = param.show, onClose = param.onClose;
    var language = useLanguage_default();
    var message = localization_default[language].groupDeletionFailed;
    if (!show) return null;
    return /* @__PURE__ */ jsx13(SnackBar_default, {
        show: show,
        type: "error",
        message: message,
        closable: true,
        onClose: onClose
    });
};
// src/components/ChannelsColumn/GroupChatDialog/ActionBar.tsx
import styled15, { useTheme as useTheme5 } from "styled-components";
import { jsx as jsx14, jsxs as jsxs9 } from "react/jsx-runtime";
var ActionBar_default = function(props) {
    var onDeleteClick = props.onDeleteClick;
    var _useViewContext_default = useViewContext_default(), selectedChannel = _useViewContext_default.selectedChannel, onCloseChannelTool = _useViewContext_default.onCloseChannelTool, channelTool = _useViewContext_default.channelTool;
    var groupChannel = useGroupChannel_default(selectedChannel, channelTool).groupChannel;
    var theme = useTheme5();
    var language = useLanguage_default();
    var isNewChannel = groupChannel.id < 1;
    return /* @__PURE__ */ jsx14(CancelContainer, {
        children: /* @__PURE__ */ jsxs9(ButtonGroup_default, {
            children: [
                /* @__PURE__ */ jsx14(Button_default, {
                    color: "primary",
                    onClick: onCloseChannelTool,
                    label: localization_default[language].cancel
                }),
                !isNewChannel && /* @__PURE__ */ jsx14(Button_default, {
                    color: "error",
                    onClick: onDeleteClick,
                    icon: /* @__PURE__ */ jsx14(Trash, {
                        color: theme.colors.primaryInverse
                    })
                })
            ]
        })
    });
};
var CancelContainer = styled15.div(_templateObject24());
// src/components/ChannelsColumn/GroupChatDialog/Loading.tsx
import styled18 from "styled-components";
// src/components/Shared/Spinner.tsx
import styled17, { keyframes as keyframes2 } from "styled-components";
// src/components/Shared/Center.tsx
import styled16 from "styled-components";
var Center_default = styled16.div(_templateObject25());
// src/components/Shared/Spinner.tsx
import { jsx as jsx15, jsxs as jsxs10 } from "react/jsx-runtime";
var getSize = function(size) {
    switch(size){
        case "normal":
            return {
                box: 40,
                width: 4
            };
        case "huge":
            return {
                box: 80,
                width: 8
            };
        case "button":
            return {
                box: 30,
                width: 3
            };
        default:
            return {
                box: 20,
                width: 2
            };
    }
};
var Spinner = function(props) {
    var size = props.size, center = props.center;
    if (center) return /* @__PURE__ */ jsx15(Center_default, {
        children: /* @__PURE__ */ jsx15(Spinner, _object_spread_props(_object_spread({}, props), {
            center: false
        }))
    });
    return /* @__PURE__ */ jsxs10(Container5, _object_spread_props(_object_spread({}, props, getSize(size)), {
        children: [
            /* @__PURE__ */ jsx15("div", {}),
            /* @__PURE__ */ jsx15("div", {}),
            /* @__PURE__ */ jsx15("div", {}),
            /* @__PURE__ */ jsx15("div", {})
        ]
    }));
};
var rings = keyframes2(_templateObject26());
var Container5 = styled17.div(_templateObject27(), function(p) {
    return p.box;
}, function(p) {
    return p.box;
}, function(p) {
    var _p_paddingTop;
    return (_p_paddingTop = p.paddingTop) !== null && _p_paddingTop !== void 0 ? _p_paddingTop : 0;
}, function(p) {
    return p.box - p.width - p.width;
}, function(p) {
    return p.box - p.width - p.width;
}, function(p) {
    return p.width;
}, function(p) {
    return p.width;
}, rings, function(p) {
    return p.theme.colors[p.color];
});
var Spinner_default = Spinner;
// src/components/ChannelsColumn/GroupChatDialog/Loading.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var Loading_default = function() {
    return /* @__PURE__ */ jsx16(Stretch, {
        children: /* @__PURE__ */ jsx16(Spinner_default, {
            center: true,
            size: "normal",
            color: "primary"
        })
    });
};
var Stretch = styled18.div(_templateObject28());
// src/components/ChannelsColumn/GroupChatDialog/DeleteGroup.tsx
import styled19, { useTheme as useTheme6 } from "styled-components";
import { useDelete } from "@bbcs/bbcs-fetch";
import { useState as useState8 } from "react";
import { jsx as jsx17, jsxs as jsxs11 } from "react/jsx-runtime";
var DeleteGroup_default = function(props) {
    var onCloseDialog = props.onCloseDialog, group = props.group;
    var deleteAsync = useDelete();
    var language = useLanguage_default();
    var _useState8 = _sliced_to_array(useState8(void 0), 2), code = _useState8[0], setCode = _useState8[1];
    var _useViewContext_default = useViewContext_default(), onBackToChannelOverview = _useViewContext_default.onBackToChannelOverview, onCloseChannelTool = _useViewContext_default.onCloseChannelTool, onReloadChannels = _useViewContext_default.onReloadChannels;
    var theme = useTheme6();
    var onDelete = function() {
        var _ref = _async_to_generator(function() {
            var response;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deleteAsync("/mentor/channels/".concat(group.id), null)
                        ];
                    case 1:
                        response = _state.sent();
                        setCode(response.code);
                        if (response.code !== 200) return [
                            2
                        ];
                        onReloadChannels();
                        onBackToChannelOverview();
                        return [
                            2
                        ];
                }
            });
        });
        return function onDelete() {
            return _ref.apply(this, arguments);
        };
    }();
    return /* @__PURE__ */ jsxs11(Container6, {
        children: [
            /* @__PURE__ */ jsx17(GroupDeleted, {
                show: code === 200,
                onClose: onCloseChannelTool
            }),
            /* @__PURE__ */ jsx17(GroupDeletionFailed, {
                show: !!code && code !== 200,
                onClose: function() {
                    return setCode(void 0);
                }
            }),
            /* @__PURE__ */ jsx17("div", {
                children: localization_default[language].groupDelete
            }),
            /* @__PURE__ */ jsx17(Separator_default, {
                show: true
            }),
            /* @__PURE__ */ jsxs11(ButtonGroup_default, {
                children: [
                    /* @__PURE__ */ jsx17(Button_default, {
                        color: "primary",
                        onClick: onCloseDialog,
                        label: localization_default[language].cancel,
                        icon: /* @__PURE__ */ jsx17(Close, {
                            color: theme.colors.primaryInverse
                        })
                    }),
                    /* @__PURE__ */ jsx17(Button_default, {
                        icon: /* @__PURE__ */ jsx17(Trash, {
                            color: theme.colors.primaryInverse
                        }),
                        color: "error",
                        onClick: onDelete,
                        label: localization_default[language].delete
                    })
                ]
            })
        ]
    });
};
var Container6 = styled19.div(_templateObject29());
// src/components/ChannelsColumn/GroupChatDialog/index.tsx
import { Fragment as Fragment2, jsx as jsx18, jsxs as jsxs12 } from "react/jsx-runtime";
var GroupChatDialog_default = function() {
    var _useViewContext_default = useViewContext_default(), selectedChannel = _useViewContext_default.selectedChannel, onBackToChannelOverview = _useViewContext_default.onBackToChannelOverview, channelTool = _useViewContext_default.channelTool, channels = _useViewContext_default.channels;
    var _usePostGroupChannel_default = usePostGroupChannel_default(), onSaveChannel = _usePostGroupChannel_default.onSaveChannel, state = _usePostGroupChannel_default.state;
    var user = useChatContext_default().user;
    var _useState9 = _sliced_to_array(useState9(false), 2), showDelete = _useState9[0], setShowDelete = _useState9[1];
    var students = useStudents_default(user.id);
    var _useGroupChannel_default = useGroupChannel_default(selectedChannel, channelTool), removeStudent = _useGroupChannel_default.removeStudent, addStudent = _useGroupChannel_default.addStudent, groupChannel = _useGroupChannel_default.groupChannel, setName = _useGroupChannel_default.setName;
    var theme = useTheme7();
    var language = useLanguage_default();
    if (!students) return /* @__PURE__ */ jsx18(Loading_default, {});
    if (showDelete) return /* @__PURE__ */ jsx18(DeleteGroup_default, {
        group: groupChannel,
        onCloseDialog: function() {
            return setShowDelete(false);
        }
    });
    var showSeparator = students.active.length > 0 && students.inactive.length > 0;
    var onSelect = function(studentId, checked) {
        if (checked) addStudent(studentId);
        else removeStudent(studentId);
    };
    var onSaved = function() {
        onBackToChannelOverview();
    };
    return /* @__PURE__ */ jsxs12(Fragment2, {
        children: [
            /* @__PURE__ */ jsx18(GroupSaved, {
                show: state === "success",
                onClose: onSaved
            }),
            /* @__PURE__ */ jsx18(GroupSavingFailed, {
                show: state === "failed",
                onClose: function() {}
            }),
            /* @__PURE__ */ jsxs12(Toolbar_default, {
                showBackToApp: false,
                children: [
                    /* @__PURE__ */ jsx18(Input_default, {
                        hasError: state === "invalid",
                        value: groupChannel.name,
                        onChange: setName,
                        placeholder: localization_default[language].groupName
                    }),
                    /* @__PURE__ */ jsx18(Button_default, {
                        onClick: function() {
                            return onSaveChannel(groupChannel, channels);
                        },
                        icon: /* @__PURE__ */ jsx18(Save, {
                            height: 24,
                            color: theme.colors.defaultInverse
                        }),
                        disabled: state === "pending"
                    })
                ]
            }),
            /* @__PURE__ */ jsxs12(Container7, {
                children: [
                    students.active.map(function(student) {
                        return /* @__PURE__ */ jsx18(StudentSelector_default, {
                            selected: groupChannel.students.includes(student.studentId),
                            active: true,
                            student: student,
                            onSelect: onSelect
                        }, student.studentId);
                    }),
                    /* @__PURE__ */ jsx18(Separator_default, {
                        show: showSeparator
                    }),
                    students.inactive.map(function(student) {
                        return /* @__PURE__ */ jsx18(StudentSelector_default, {
                            selected: groupChannel.students.includes(student.studentId),
                            active: false,
                            student: student,
                            onSelect: onSelect
                        }, student.studentId);
                    }),
                    /* @__PURE__ */ jsx18(Separator_default, {
                        show: true
                    }),
                    /* @__PURE__ */ jsx18(ActionBar_default, {
                        onDeleteClick: function() {
                            return setShowDelete(true);
                        }
                    })
                ]
            })
        ]
    });
};
var Container7 = styled20.div(_templateObject30());
// src/components/ChannelsColumn/ChannelsView/index.tsx
import { useContext as useContext3, useState as useState13 } from "react";
import styled25, { useTheme as useTheme9 } from "styled-components";
// src/hooks/useSearch.ts
import { usePost as usePost2 } from "@bbcs/bbcs-fetch";
import { useEffect as useEffect5, useState as useState10 } from "react";
var useSearch_default = function(term) {
    var post = usePost2();
    var _useState10 = _sliced_to_array(useState10(), 2), results = _useState10[0], setResults = _useState10[1];
    useEffect5(function() {
        if (!term || term.trim().length < 3) {
            setResults(void 0);
            return;
        }
        post("/user/channels/search-messages", {
            term: term
        }).then(function(response) {
            if (response.ok) setResults(response.body);
        });
    }, [
        term
    ]);
    return results;
};
// src/hooks/useChannelState.ts
import { useEffect as useEffect6, useState as useState11 } from "react";
// src/hooks/useChat.ts
import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
// src/classes/Connector.ts
import { HubConnectionState } from "@microsoft/signalr";
// src/types/EventHandler.ts
var EventHandler = /*#__PURE__*/ function() {
    "use strict";
    function EventHandler() {
        _class_call_check(this, EventHandler);
        this.listeners = [];
    }
    _create_class(EventHandler, [
        {
            key: "addListener",
            value: function addListener(listener) {
                this.removeListener(listener);
                this.listeners.push(listener);
            }
        },
        {
            key: "removeListener",
            value: function removeListener(listener) {
                if (!this.listeners.includes(listener)) return;
                this.listeners = this.listeners.filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "dispatch",
            value: function dispatch(event) {
                this.listeners.forEach(function(l) {
                    return l(event);
                });
            }
        }
    ]);
    return EventHandler;
}();
// src/classes/Connector.ts
var logError = function(error) {
    return console.log("connector error", error);
};
var Connector = /*#__PURE__*/ function() {
    "use strict";
    function Connector(connection, user) {
        var _this = this;
        _class_call_check(this, Connector);
        this.onBadgeUpdate = new EventHandler();
        this.onMessageSend = new EventHandler();
        this.onMessageSending = new EventHandler();
        this.onMessageDelivered = new EventHandler();
        this.onMessageReceived = new EventHandler();
        this.onMessagesRead = new EventHandler();
        this.onChannelStateChange = new EventHandler();
        this.onConnected = new EventHandler();
        this.onDisconnected = new EventHandler();
        this.onChannelReceiversChanged = new EventHandler();
        this.isConnected = function() {
            var _this_connection;
            return ((_this_connection = _this.connection) === null || _this_connection === void 0 ? void 0 : _this_connection.state) === HubConnectionState.Connected;
        };
        this.connection = connection;
        this.channelId = null;
        this.user = user;
        var ref = this;
        var connected = function() {
            ref.connected();
        };
        var disconnected = function() {
            ref.disconnected();
        };
        connection.start().then(connected).catch(logError);
        connection.onclose(disconnected);
        connection.onreconnected(connected);
        connection.onreconnecting(disconnected);
        connection.on("onJoinChannel", function(args) {
            return ref.channelJoinedHandler(args);
        });
        connection.on("onReportedChannelState", function(args) {
            return ref.reportedChannelStateHandler(args);
        });
        connection.on("onReportChannelState", function(args) {
            return ref.reportChannelStateHandler(args);
        });
        connection.on("onMessageReceive", function(args) {
            return ref.messageReceivedHandler(args);
        });
        connection.on("onMessageSend", function(args) {
            return ref.messageSendHandler(args);
        });
        connection.on("onMessageRead", function(args) {
            return ref.messageReadHandler(args);
        });
        connection.on("onChannelReceiversChanged", function(args) {
            return ref.channelReceiversChanged(args);
        });
    }
    _create_class(Connector, [
        {
            key: "disconnect",
            value: function disconnect() {
                var _this_connection;
                (_this_connection = this.connection) === null || _this_connection === void 0 ? void 0 : _this_connection.stop();
            }
        },
        {
            key: "joinChannel",
            value: function joinChannel(channelId) {
                var ref = this;
                this.channelId = channelId;
                this.connection.invoke("JoinChannel", channelId).catch(function() {
                    ref.leaveChannel(channelId);
                });
            }
        },
        {
            key: "leaveChannel",
            value: function leaveChannel(channelId) {
                if (!this.connection || !this.isConnected()) return;
                this.connection.invoke("LeaveChannel", channelId).catch(logError);
                this.channelId = null;
            }
        },
        {
            /** This message will send the given message */ key: "sendMessage",
            value: function sendMessage(message) {
                var _this = this;
                this.onMessageSending.dispatch(message);
                this.connection.invoke("SendMessage", message).catch(function(err) {
                    var event = {
                        result: "sending-error",
                        exception: err,
                        tempId: message.tempId,
                        messageId: null
                    };
                    _this.onMessageSend.dispatch(event);
                });
            }
        },
        {
            /** this method marks the given messages as read */ key: "markMessageAsRead",
            value: function markMessageAsRead(channelId, messageId) {
                this.connection.invoke("MessagesRead", channelId, messageId).catch(logError);
            }
        },
        {
            /**  ask to report the current state to the given user */ key: "reportChannelStateHandler",
            value: function reportChannelStateHandler(requestInfo) {
                if (this.channelId !== requestInfo.channelId) return;
                this.connection.invoke("ReportChannelState", requestInfo.channelId, "online", requestInfo.userId).catch(logError);
            }
        },
        {
            /** reports the state of a user in a channel, state can be 'online' or 'leave' */ key: "reportedChannelStateHandler",
            value: function reportedChannelStateHandler(stateInfo) {
                if (!stateInfo || stateInfo.userId === this.user.id) return;
                try {
                    this.onChannelStateChange.dispatch(stateInfo);
                } catch (err) {}
            }
        },
        {
            /** This handler responses from the server when a message has been sent by this user */ key: "messageSendHandler",
            value: function messageSendHandler(messageInfo) {
                if (!messageInfo) return;
                this.onMessageSend.dispatch(messageInfo);
            }
        },
        {
            /** confirmation that a channel is joined, a list with user in that channel id is sent */ key: "channelJoinedHandler",
            value: function channelJoinedHandler(channelInfo) {
                if (!channelInfo || !this.channelId) return;
                if (channelInfo.channelId !== this.channelId) return;
                this.connection.invoke("WhoIsInChannel", this.channelId).catch(logError);
            }
        },
        {
            /** A new message has been received (can be outside the current channel) */ key: "messageReceivedHandler",
            value: function messageReceivedHandler(message) {
                if (message.senderId !== this.user.id) this.onBadgeUpdate.dispatch({
                    channelId: message.channelId,
                    count: 1
                });
                if (message.channelId !== this.channelId) return;
                if (message.senderId !== this.user.id) this.onMessageReceived.dispatch(message);
                else this.onMessageDelivered.dispatch(_object_spread_props(_object_spread({}, message), {
                    sendState: "delivered"
                }));
            }
        },
        {
            /** A message is read by a user */ key: "messageReadHandler",
            value: function messageReadHandler(readInfo) {
                if (readInfo == null) return;
                if (readInfo.userId === this.user.id) {
                    this.onBadgeUpdate.dispatch({
                        channelId: readInfo.channelId,
                        count: -1
                    });
                }
                this.onMessagesRead.dispatch(readInfo);
            }
        },
        {
            /** a channel the user is part of has updated receivers */ key: "channelReceiversChanged",
            value: function channelReceiversChanged(info) {
                this.onChannelReceiversChanged.dispatch(info);
            }
        },
        {
            key: "connected",
            value: function connected() {
                this.onConnected.dispatch();
            }
        },
        {
            key: "disconnected",
            value: function disconnected() {
                this.onDisconnected.dispatch();
            }
        }
    ]);
    return Connector;
}();
// src/hooks/useChat.ts
var useChat_default = function() {
    var chat = window.chat;
    if (chat) return chat;
    return void 0;
};
var disconnect = function() {
    window.chat = null;
};
var oneMinuteReconnectPolicy = {
    nextRetryDelayInMilliseconds: function(retryContext) {
        if (retryContext.previousRetryCount < 1) return 10;
        if (retryContext.previousRetryCount < 10) return 100;
        if (retryContext.previousRetryCount < 100) return 1e3;
        return 2e3;
    }
};
var connect = function(fetchContext, user) {
    if (window.chat) return;
    var config = fetchContext.config;
    var options = {
        accessTokenFactory: function accessTokenFactory() {
            var _fetchContext_user;
            var _fetchContext_user_token;
            return (_fetchContext_user_token = (_fetchContext_user = fetchContext.user) === null || _fetchContext_user === void 0 ? void 0 : _fetchContext_user.token) !== null && _fetchContext_user_token !== void 0 ? _fetchContext_user_token : "";
        }
    };
    var connection = new HubConnectionBuilder().withUrl("".concat(config.api, "/chat/server"), options).withAutomaticReconnect(oneMinuteReconnectPolicy).configureLogging(LogLevel.Information).build();
    window.chat = new Connector(connection, user);
};
// src/hooks/useChannelState.ts
var useChannelState_default = function(channelId) {
    var _useState11 = _sliced_to_array(useState11([]), 2), online = _useState11[0], setOnline = _useState11[1];
    var user = useChatContext_default().user;
    var connector = useChat_default();
    useEffect6(function() {
        if (!user || !connector) return function() {};
        var listener = function(event) {
            if (event.channelId !== channelId || event.userId === user.id) return;
            if (event.state === "offline") setOnline(online.filter(function(o) {
                return o.userId !== event.userId;
            }));
            else {
                var contains = online.find(function(o) {
                    return o.userId === event.userId;
                });
                if (!contains) setOnline(_to_consumable_array(online).concat([
                    event
                ]));
            }
        };
        connector.onChannelStateChange.addListener(listener);
        return function() {
            connector.onChannelStateChange.removeListener(listener);
        };
    }, [
        connector,
        channelId,
        user
    ]);
    return {
        channelId: channelId,
        online: online
    };
};
// src/components/ChannelsColumn/ChannelsView/ChannelDetails.tsx
import { useEffect as useEffect7, useState as useState12 } from "react";
import styled22, { useTheme as useTheme8 } from "styled-components";
// src/components/Shared/Online.tsx
import styled21 from "styled-components";
var Online_default = styled21.div(_templateObject31(), function(p) {
    return p.theme.colors.secondary;
}, function(p) {
    return p.show ? "inline-block" : "none";
});
// src/components/Shared/isOnline.ts
var isOnline_default = function(channel, state, user) {
    if (!channel || !user || !state || state.channelId !== channel.id) return false;
    if (channel.type !== ChannelType_default.Personal) return false;
    return state.online.length > 0;
};
// src/components/ChannelsColumn/ChannelsView/ChannelDetails.tsx
import { jsx as jsx19, jsxs as jsxs13 } from "react/jsx-runtime";
var ChannelDetails_default = function(props) {
    var channel = props.channel, selected = props.selected, onSelect = props.onSelect, _props_hideOnline = props.hideOnline, hideOnline = _props_hideOnline === void 0 ? false : _props_hideOnline, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled;
    var user = useChatContext_default().user;
    var connector = useChat_default();
    var theme = useTheme8();
    var _useState12 = _sliced_to_array(useState12(channel.unreadCount), 2), unreadCount = _useState12[0], setUnreadCount = _useState12[1];
    var state = useChannelState_default(channel === null || channel === void 0 ? void 0 : channel.id);
    var online = isOnline_default(channel, state, user);
    var color = selected ? theme.colors.primary : theme.colors.tertiary;
    useEffect7(function() {
        var listener = function(event) {
            if (channel.id === event.channelId) setUnreadCount(function(c) {
                return Math.max(c + event.count, 0);
            });
        };
        connector === null || connector === void 0 ? void 0 : connector.onBadgeUpdate.addListener(listener);
        return function() {
            connector === null || connector === void 0 ? void 0 : connector.onBadgeUpdate.removeListener(listener);
        };
    }, []);
    var others = channel.receivers.filter(function(r) {
        return r.userId !== (user === null || user === void 0 ? void 0 : user.id);
    });
    var other = others.length === 1 ? others[0] : null;
    return /* @__PURE__ */ jsxs13(Container2, {
        disabled: disabled,
        onClick: function() {
            return onSelect(channel);
        },
        selected: selected,
        children: [
            /* @__PURE__ */ jsxs13("div", {
                children: [
                    !other && /* @__PURE__ */ jsx19(Pos, {
                        children: /* @__PURE__ */ jsx19(UserGroup, {
                            color: color,
                            height: 26
                        })
                    }),
                    other && /* @__PURE__ */ jsx19(Avatar_default, {
                        grayscale: other.userActive === false,
                        size: 28,
                        avatarUrl: other.userAvatarUrl
                    })
                ]
            }),
            /* @__PURE__ */ jsx19("div", {
                children: channel.name
            }),
            /* @__PURE__ */ jsx19(Online_default, {
                show: online && !hideOnline
            }),
            /* @__PURE__ */ jsx19(Spacer_default, {}),
            /* @__PURE__ */ jsx19(Badge, {
                selected: selected,
                show: unreadCount !== 0,
                children: unreadCount
            })
        ]
    });
};
var Badge = styled22.div(_templateObject32(), function(p) {
    return p.selected ? p.theme.colors.primary : p.theme.colors.tertiary;
}, function(p) {
    return p.selected ? p.theme.colors.primaryInverse : p.theme.colors.tertiaryInverse;
}, function(p) {
    return p.show ? "flex" : "none";
});
var Pos = styled22.div(_templateObject33());
// src/components/ChannelsColumn/ChannelsView/SearchResult.tsx
import styled24 from "styled-components";
// src/components/Shared/Link.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
var Link_default = function(props) {
    var className = props.className, href = props.href, color = props.color, children = props.children, target = props.target;
    var navigate = useChatContext_default().navigate;
    var rel = target ? "noreferrer" : void 0;
    var style = color ? {
        color: color
    } : {};
    var onLinkClick = function(event) {
        event.preventDefault();
        navigate(href);
    };
    return /* @__PURE__ */ jsx20("a", {
        onClick: onLinkClick,
        className: className,
        target: target,
        rel: rel,
        style: style,
        href: "#",
        children: children
    });
};
// src/components/Shared/TextWithLinks.tsx
import { useMemo } from "react";
import styled23 from "styled-components";
// src/util/stripTags.ts
var stripTags_default = function(html) {
    return html === null || html === void 0 ? void 0 : html.replace(/<[^>]+>/g, "").replace("&nbsp;", " ");
};
// src/util/subString.ts
var getHead = function(text, needle) {
    var index = text.indexOf(needle);
    if (index === -1) return text;
    return text.substring(0, index);
};
var getTails = function(text, needle) {
    var index = text.indexOf(needle);
    if (index === -1) return text;
    return text.substring(index + needle.length);
};
// src/components/Shared/TextWithLinks.tsx
import { Fragment as Fragment3, jsx as jsx21, jsxs as jsxs14 } from "react/jsx-runtime";
var TextWithLinks_default = function(props) {
    var text = props.text, mark = props.mark;
    if (isEmpty_default(text)) return null;
    if (!containsLink(text)) return /* @__PURE__ */ jsx21(Mark, {
        text: text,
        term: mark
    });
    var parts = useMemo(function() {
        var _stripTags_default;
        return split((_stripTags_default = stripTags_default(text)) !== null && _stripTags_default !== void 0 ? _stripTags_default : "");
    }, [
        text
    ]);
    return /* @__PURE__ */ jsx21(Fragment3, {
        children: parts.map(function(value, index) {
            return /* @__PURE__ */ jsx21(Value, {
                mark: mark,
                content: value
            }, index);
        })
    });
};
var containsLink = function(text) {
    return text.includes("http:") || text.includes("https:") || text.includes("www.");
};
var Value = function(props) {
    var content = props.content, mark = props.mark;
    var type = content.type, value = content.value;
    if (type !== "link") return /* @__PURE__ */ jsx21(Mark, {
        text: "".concat(value, " "),
        term: mark
    });
    return /* @__PURE__ */ jsxs14(Fragment3, {
        children: [
            /* @__PURE__ */ jsx21(Link_default, {
                target: "_blank",
                href: value,
                children: value
            }),
            " "
        ]
    });
};
var split = function(text) {
    return text.split(" ").filter(function(t) {
        return !isEmpty_default(t);
    }).map(analyze);
};
var analyze = function(text) {
    if (text.startsWith("https://")) return {
        type: "link",
        value: text
    };
    if (text.startsWith("http://")) return {
        type: "link",
        value: text
    };
    if (text.startsWith("www.")) return {
        type: "link",
        value: "https://".concat(text)
    };
    return {
        type: "text",
        value: text
    };
};
var Mark = function(props) {
    var term = props.term, text = props.text;
    if (!term || !text.includes(term)) return /* @__PURE__ */ jsx21(NewLine, {
        text: text
    });
    var head = getHead(text, term);
    var tail = getTails(text, term);
    return /* @__PURE__ */ jsxs14(Fragment3, {
        children: [
            /* @__PURE__ */ jsx21(NewLine, {
                text: head
            }),
            /* @__PURE__ */ jsx21(Bold, {
                children: /* @__PURE__ */ jsx21(NewLine, {
                    text: term
                })
            }),
            /* @__PURE__ */ jsx21(Mark, {
                text: tail,
                term: term
            })
        ]
    });
};
var NewLine = function(props) {
    var text = props.text;
    if (isEmpty_default(text)) return null;
    var parts = text.trim().replace("\r\n", "\n").split("\n");
    if (parts.length === 1) return /* @__PURE__ */ jsx21(Fragment3, {
        children: text
    });
    return parts.reduce(function(content, current, index) {
        if (index === 0) return /* @__PURE__ */ jsx21(Fragment3, {
            children: current
        });
        return /* @__PURE__ */ jsxs14(Fragment3, {
            children: [
                content,
                /* @__PURE__ */ jsx21("br", {}),
                current
            ]
        });
    }, /* @__PURE__ */ jsx21(Fragment3, {}));
};
var Bold = styled23.span(_templateObject34());
// src/components/ChannelsColumn/ChannelsView/SearchResult.tsx
import { Fragment as Fragment4, jsx as jsx22, jsxs as jsxs15 } from "react/jsx-runtime";
var SearchResult_default = function(props) {
    var results = props.results, targetMessageId = props.targetMessageId, searchTerm = props.searchTerm, channels = props.channels, onBrowseToMessage = props.onBrowseToMessage;
    var lookup = createLookup(results);
    return /* @__PURE__ */ jsx22(Fragment4, {
        children: channels.map(function(c) {
            return /* @__PURE__ */ jsx22(ChannelResults, {
                onBrowseToMessage: onBrowseToMessage,
                searchTerm: searchTerm,
                targetMessageId: targetMessageId,
                results: lookup[c.id],
                channel: c
            }, c.id);
        })
    });
};
var ChannelResults = function(props) {
    var channel = props.channel, searchTerm = props.searchTerm, results = props.results, onBrowseToMessage = props.onBrowseToMessage, targetMessageId = props.targetMessageId;
    if (!results) return null;
    return /* @__PURE__ */ jsx22(Fragment4, {
        children: results.map(function(r) {
            return /* @__PURE__ */ jsx22(ResultDetail, {
                onBrowseToMessage: onBrowseToMessage,
                channel: channel,
                result: r,
                selected: r.channelId === channel.id && r.messageId === targetMessageId,
                searchTerm: searchTerm
            }, r.messageId);
        })
    });
};
var ResultDetail = function(props) {
    var channel = props.channel, searchTerm = props.searchTerm, result = props.result, selected = props.selected, onBrowseToMessage = props.onBrowseToMessage;
    return /* @__PURE__ */ jsxs15(Hover, {
        children: [
            /* @__PURE__ */ jsx22(ChannelDetails_default, {
                hideOnline: true,
                disabled: true,
                channel: channel,
                selected: selected,
                onSelect: function() {
                    return onBrowseToMessage(result.messageId, channel);
                }
            }),
            /* @__PURE__ */ jsx22(ContentPreview, {
                selected: selected,
                onClick: function() {
                    return onBrowseToMessage(result.messageId, channel);
                },
                children: /* @__PURE__ */ jsx22(TextWithLinks_default, {
                    mark: searchTerm,
                    text: result.content
                })
            })
        ]
    });
};
var Hover = styled24.div(_templateObject35(), function(p) {
    return p.theme.colors.default;
}, function(p) {
    return p.theme.colors.default;
}, function(p) {
    return p.theme.colors.defaultSupport;
});
var ContentPreview = styled24.div(_templateObject36(), function(p) {
    return p.selected ? p.theme.colors.primary : p.theme.colors.default;
});
var createLookup = function(results) {
    var lookup = {};
    results.forEach(function(result) {
        if (!lookup[result.channelId]) lookup[result.channelId] = [];
        lookup[result.channelId].push(result);
    });
    return lookup;
};
// src/components/ChannelsColumn/ChannelsView/index.tsx
import { Fragment as Fragment5, jsx as jsx23, jsxs as jsxs16 } from "react/jsx-runtime";
var ChannelsView_default = function(props) {
    var onBrowseToMessage = props.onBrowseToMessage;
    var _useViewContext_default = useViewContext_default(), selectedChannel = _useViewContext_default.selectedChannel, channels = _useViewContext_default.channels, onShowMessages = _useViewContext_default.onShowMessages, onShowChannelTool = _useViewContext_default.onShowChannelTool, targetMessageId = _useViewContext_default.targetMessageId, showBackToDashboard = _useViewContext_default.showBackToDashboard;
    var _useState13 = _sliced_to_array(useState13(""), 2), search = _useState13[0], setSearch = _useState13[1];
    var language = useLanguage_default();
    var searchResult = useSearch_default(search);
    var context = useContext3(ChatContext_default);
    var theme = useTheme9();
    var hasResults = searchResult && searchResult.length > 0;
    var isMentor = context.user.role === "Mentor" /* Mentor */ ;
    var onBrowse = function(messageId, channel) {
        return onBrowseToMessage(messageId, channel, search);
    };
    return /* @__PURE__ */ jsxs16(Fragment5, {
        children: [
            /* @__PURE__ */ jsxs16(Toolbar_default, {
                showBackToApp: showBackToDashboard,
                children: [
                    /* @__PURE__ */ jsx23(Input_default, {
                        value: search,
                        onChange: setSearch,
                        placeholder: localization_default[language].searchInMessages
                    }),
                    /* @__PURE__ */ jsx23(Button_default, {
                        hidden: !isMentor || context.showChannelTools !== true,
                        onClick: function() {
                            return onShowChannelTool(ChannelTool_default.CreateGroup);
                        },
                        icon: /* @__PURE__ */ jsx23(AddGroup, {
                            height: 24,
                            color: theme.colors.defaultInverse
                        })
                    })
                ]
            }),
            /* @__PURE__ */ jsxs16(Container8, {
                children: [
                    !hasResults && channels.map(function(c) {
                        return /* @__PURE__ */ jsx23(ChannelDetails_default, {
                            channel: c,
                            selected: c.id === (selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.id),
                            onSelect: onShowMessages
                        }, c.id);
                    }),
                    hasResults && /* @__PURE__ */ jsx23(SearchResult_default, {
                        searchTerm: search,
                        onBrowseToMessage: onBrowse,
                        targetMessageId: targetMessageId,
                        results: searchResult,
                        channels: channels
                    })
                ]
            })
        ]
    });
};
var Container8 = styled25.div(_templateObject37());
// src/components/ChannelsColumn/index.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
var ChannelsColumn_default = function(props) {
    var viewMode = useViewContext_default().viewMode;
    var _useChatContext_default = useChatContext_default(), _useChatContext_default_maxWidthForChannelView = _useChatContext_default.maxWidthForChannelView, maxWidthForChannelView = _useChatContext_default_maxWidthForChannelView === void 0 ? 400 : _useChatContext_default_maxWidthForChannelView;
    return /* @__PURE__ */ jsx24(ChannelContainer, {
        viewMode: viewMode,
        maxChannelWidth: maxWidthForChannelView,
        children: /* @__PURE__ */ jsx24(Switch, _object_spread({}, props))
    });
};
var Switch = function(props) {
    var _useViewContext_default = useViewContext_default(), channelTool = _useViewContext_default.channelTool, selectedChannel = _useViewContext_default.selectedChannel;
    var _useChatContext_default = useChatContext_default(), user = _useChatContext_default.user, showChannelTools = _useChatContext_default.showChannelTools;
    var isMentor = user.role === "Mentor" /* Mentor */ ;
    if (showChannelTools !== true) return /* @__PURE__ */ jsx24(ChannelsView_default, _object_spread({}, props));
    switch(channelTool){
        case ChannelTool_default.ChannelView:
            return /* @__PURE__ */ jsx24(ChannelsView_default, _object_spread({}, props));
        case ChannelTool_default.CreateGroup:
            if (isMentor) return /* @__PURE__ */ jsx24(GroupChatDialog_default, {});
            break;
        case ChannelTool_default.ChannelInfo:
            if (isMentor && selectedChannel.type === ChannelType_default.Private) return /* @__PURE__ */ jsx24(GroupChatDialog_default, {});
            return /* @__PURE__ */ jsx24(GroupInfo_default, {});
        default:
            return null;
    }
    return null;
};
var ChannelContainer = styled26.div(_templateObject38(), function(p) {
    return p.viewMode !== ViewMode_default.Messages ? "initial" : "none";
}, function(p) {
    return p.viewMode === ViewMode_default.Channel ? "100%" : "100vw";
}, function(p) {
    return p.viewMode === ViewMode_default.Channel ? "100%" : "".concat(p.maxChannelWidth, "px");
}, function(p) {
    return p.theme.colors.defaultSupport;
});
// src/components/Shared/Block.tsx
import styled27 from "styled-components";
import { jsx as jsx25 } from "react/jsx-runtime";
var Block_default = function(props) {
    var children = props.children;
    return /* @__PURE__ */ jsx25(Container9, {
        children: /* @__PURE__ */ jsx25(Box, {
            className: "box",
            children: children
        })
    });
};
var Container9 = styled27.div(_templateObject39());
var Box = styled27.div(_templateObject40(), function(p) {
    return p.theme.maxWidth;
}, function(p) {
    return p.theme.screens.medium;
});
// src/components/Shared/Text.tsx
import styled28 from "styled-components";
import { jsx as jsx26 } from "react/jsx-runtime";
var Text = function(props) {
    var variant = props.variant, children = props.children;
    switch(variant){
        case "h1":
            return /* @__PURE__ */ jsx26(H1, _object_spread_props(_object_spread({}, props), {
                children: children
            }));
        default:
            return /* @__PURE__ */ jsx26(P, _object_spread_props(_object_spread({}, props), {
                children: children
            }));
    }
};
var H1 = styled28.h1(_templateObject41(), function(p) {
    var _p_color;
    return p.theme.colors[(_p_color = p.color) !== null && _p_color !== void 0 ? _p_color : "default"];
});
var getTextAlign = function(style) {
    var center = style.center, justify = style.justify;
    if (center === true) return "center";
    if (justify === true) return "justify";
    return "left";
};
var P = styled28.p(_templateObject42(), function(p) {
    var _p_color;
    return p.theme.colors[(_p_color = p.color) !== null && _p_color !== void 0 ? _p_color : "default"];
}, function(p) {
    return getTextAlign(p);
}, function(p) {
    return p.margin !== void 0 ? "margin: ".concat(p.margin, "px") : "";
}, function(p) {
    return p.bold ? "bold" : 300;
}, function(p) {
    return p.italic ? "italic" : "normal";
}, function(p) {
    var _p_color;
    return p.theme.colors[(_p_color = p.color) !== null && _p_color !== void 0 ? _p_color : "default"];
});
var Text_default = Text;
// src/components/NoChannels.tsx
import styled29 from "styled-components";
import { jsx as jsx27, jsxs as jsxs17 } from "react/jsx-runtime";
var NoChannels_default = function() {
    var language = useLanguage_default();
    return /* @__PURE__ */ jsxs17(Block_default, {
        children: [
            /* @__PURE__ */ jsx27(Text_default, {
                variant: "h1",
                children: localization_default[language].title
            }),
            /* @__PURE__ */ jsx27(Center_default, {
                children: /* @__PURE__ */ jsx27(Text_default, {
                    margin: 0,
                    children: localization_default[language].noChannel
                })
            }),
            /* @__PURE__ */ jsx27(Padding, {
                children: /* @__PURE__ */ jsx27(Center_default, {
                    children: /* @__PURE__ */ jsx27(Button_default, {
                        href: "/user/dashboard",
                        label: localization_default[language].dashboard
                    })
                })
            })
        ]
    });
};
var Padding = styled29.div(_templateObject43());
// src/hooks/useMessages.ts
import { useGetAsync as useGetAsync3 } from "@bbcs/bbcs-fetch";
import { useEffect as useEffect14, useState as useState14 } from "react";
// src/hooks/useChannelActions.ts
import { useEffect as useEffect8 } from "react";
var useChannelActions_default = function(channelId) {
    var connector = useChat_default();
    useEffect8(function() {
        if (channelId) connector === null || connector === void 0 ? void 0 : connector.joinChannel(channelId);
        return function() {
            if (channelId) connector === null || connector === void 0 ? void 0 : connector.leaveChannel(channelId);
        };
    }, [
        channelId
    ]);
};
// src/hooks/useOnMessageDelivered.ts
import { useEffect as useEffect9 } from "react";
var useOnMessageDelivered_default = function(setMessages) {
    var connector = useChat_default();
    useEffect9(function() {
        if (!connector) return function() {};
        var listener = function(event) {
            setMessages(function(messages) {
                return updateState(messages, event);
            });
        };
        connector.onMessageDelivered.addListener(listener);
        return function() {
            connector.onMessageDelivered.removeListener(listener);
        };
    }, [
        connector,
        setMessages
    ]);
};
var updateState = function(messages, event) {
    var current = messages !== null && messages !== void 0 ? messages : [];
    var message = current.find(function(m) {
        return m.id === event.id;
    });
    if (!message) message = current.find(function(m) {
        return m.tempId === event.tempId;
    });
    if (!message) return [
        _object_spread_props(_object_spread({}, event), {
            isSender: true
        })
    ].concat(_to_consumable_array(current));
    message.sendState = event.sendState;
    return _to_consumable_array(current);
};
// src/hooks/useOnMessageReceived.ts
import { useEffect as useEffect10 } from "react";
var useOnMessageReceived_default = function(channel, setReceivedMessageId, setMessages) {
    var connector = useChat_default();
    useEffect10(function() {
        if (!connector) return function() {};
        var listener = function(message) {
            if (!channel || channel.id !== message.channelId) return;
            setMessages(function(messages) {
                if (message.tempId && (messages === null || messages === void 0 ? void 0 : messages.find(function(m) {
                    return m.tempId === message.tempId;
                }))) return messages;
                if (messages === null || messages === void 0 ? void 0 : messages.find(function(m) {
                    return m.id === message.id;
                })) return messages;
                return [
                    message
                ].concat(_to_consumable_array(messages !== null && messages !== void 0 ? messages : []));
            });
            setReceivedMessageId(message.id);
        };
        connector.onMessageReceived.addListener(listener);
        return function() {
            connector.onMessageReceived.removeListener(listener);
        };
    }, [
        channel,
        setMessages,
        connector
    ]);
};
// src/hooks/useOnMessageSend.ts
import { useEffect as useEffect11 } from "react";
var useOnMessageSend_default = function(setMessages) {
    var connector = useChat_default();
    useEffect11(function() {
        if (!connector) return function() {};
        var listener = function(event) {
            setMessages(function(messages) {
                return updateState2(messages, event);
            });
        };
        connector.onMessageSend.addListener(listener);
        return function() {
            connector.onMessageSend.removeListener(listener);
        };
    }, [
        connector,
        setMessages
    ]);
};
var updateState2 = function(messages, event) {
    var current = messages !== null && messages !== void 0 ? messages : [];
    var message = current.find(function(m) {
        return m.tempId === event.tempId;
    });
    if (!message) return current;
    var isSend = event.result === "success";
    if (isSend) message.id = parseInt(event.messageId);
    message.sendState = event.result;
    return _to_consumable_array(current);
};
// src/hooks/useOnMessageSending.ts
import { useEffect as useEffect12 } from "react";
// src/types/MessageType.ts
var MessageType = /* @__PURE__ */ function(MessageType2) {
    MessageType2["StudentLessonSubmission"] = "StudentLessonSubmission";
    MessageType2["Text"] = "Text";
    MessageType2["NameChange"] = "NameChange";
    MessageType2["MentorLessonSubmissionReview"] = "MentorLessonSubmissionReview";
    MessageType2["StudentEnrollment"] = "StudentEnrollment";
    MessageType2["MentorAnswerReview"] = "MentorAnswerReview";
    MessageType2["MentorChangeLeave"] = "MentorChangeLeave";
    MessageType2["MentorChangeEnter"] = "MentorChangeEnter";
    return MessageType2;
}(MessageType || {});
var MessageType_default = MessageType;
// src/hooks/useOnMessageSending.ts
var useOnMessageSending_default = function(setMessages) {
    var connector = useChat_default();
    useEffect12(function() {
        if (!connector) return function() {};
        var listener = function(outgoing) {
            setMessages(function(messages) {
                if (messages === null || messages === void 0 ? void 0 : messages.find(function(m) {
                    return m.tempId === outgoing.tempId;
                })) return messages;
                var message = convert(outgoing, messages === null || messages === void 0 ? void 0 : messages.length);
                return [
                    _object_spread({}, message)
                ].concat(_to_consumable_array(messages !== null && messages !== void 0 ? messages : []));
            });
        };
        connector.onMessageSending.addListener(listener);
        return function() {
            connector.onMessageSending.removeListener(listener);
        };
    }, [
        connector,
        setMessages
    ]);
};
var convert = function(outgoing, messages) {
    var now = new Date(Date.now());
    return _object_spread_props(_object_spread({}, outgoing), {
        id: -1 * (messages !== null && messages !== void 0 ? messages : 1),
        senderDate: now.toUTCString(),
        isSender: true,
        type: MessageType_default.Text,
        isDeleted: false,
        receivers: outgoing.receivers.map(function(r) {
            return _object_spread_props(_object_spread({}, r), {
                hasRead: r.userId === outgoing.senderId,
                readDate: r.userId === outgoing.senderId ? now : null
            });
        }),
        sendState: "sending"
    });
};
// src/hooks/useOnMessagesRead.ts
import { useEffect as useEffect13 } from "react";
var useOnMessagesRead_default = function(setMessages) {
    var connector = useChat_default();
    useEffect13(function() {
        if (!connector) return function() {};
        var listener = function(event) {
            setMessages(function(messages) {
                return updateMessages(messages, event);
            });
        };
        connector.onMessagesRead.addListener(listener);
        return function() {
            connector.onMessagesRead.removeListener(listener);
        };
    }, [
        connector,
        setMessages
    ]);
};
var updateMessages = function(messages, event) {
    if (!messages) return messages;
    var contains = messages.find(function(m) {
        return m.id === event.messageId;
    });
    if (!contains) return messages;
    contains.receivers = contains.receivers.map(function(receiver) {
        return updateReceivers(receiver, event);
    });
    return _to_consumable_array(messages);
};
var updateReceivers = function(receiver, event) {
    if (receiver.userId !== event.userId) return _object_spread({}, receiver);
    var now = new Date(Date.now()).toISOString();
    return _object_spread_props(_object_spread({}, receiver), {
        readDate: now,
        hasRead: true
    });
};
// src/hooks/useMessages.ts
var take = 50;
var fetchData = function() {
    var _ref = _async_to_generator(function(get, channelId, targetMessageId) {
        var result, messages, contains, _result_body, takeValue;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        get("/user/channels/".concat(channelId, "/messages?take=50"))
                    ];
                case 1:
                    result = _state.sent();
                    if (!result.ok) return [
                        2,
                        null
                    ];
                    if (!targetMessageId) return [
                        2,
                        result.body
                    ];
                    messages = result.body;
                    contains = messages.find(function(m) {
                        return m.id === targetMessageId;
                    });
                    _state.label = 2;
                case 2:
                    if (!!contains) return [
                        3,
                        4
                    ];
                    takeValue = Math.max(take, messages.length);
                    return [
                        4,
                        get("/user/channels/".concat(channelId, "/messages?skip=").concat(messages.length, "&take=").concat(takeValue))
                    ];
                case 3:
                    result = _state.sent();
                    if (!result.ok) return [
                        2,
                        messages
                    ];
                    contains = result.body.find(function(m) {
                        return m.id === targetMessageId;
                    });
                    messages = messages.concat(result.body);
                    if (((_result_body = result.body) === null || _result_body === void 0 ? void 0 : _result_body.length) === 0) return [
                        2,
                        messages
                    ];
                    return [
                        3,
                        2
                    ];
                case 4:
                    return [
                        2,
                        messages
                    ];
            }
        });
    });
    return function fetchData(get, channelId, targetMessageId) {
        return _ref.apply(this, arguments);
    };
}();
var useMessages_default = function(channel, targetMessageId) {
    var get = useGetAsync3();
    var _useState14 = _sliced_to_array(useState14(), 2), messages = _useState14[0], setMessages = _useState14[1];
    var _useState141 = _sliced_to_array(useState14(true), 2), moreMessageAvailable = _useState141[0], setMoreMessageAvailable = _useState141[1];
    var _useState142 = _sliced_to_array(useState14(void 0), 2), receivedMessageId = _useState142[0], setReceivedMessageId = _useState142[1];
    useOnMessageSending_default(setMessages);
    useOnMessageSend_default(setMessages);
    useOnMessageReceived_default(channel, setReceivedMessageId, setMessages);
    useOnMessageDelivered_default(setMessages);
    useOnMessagesRead_default(setMessages);
    useChannelActions_default(channel === null || channel === void 0 ? void 0 : channel.id);
    useEffect14(function() {
        setMessages(void 0);
        setMoreMessageAvailable(true);
        var fetch = function() {
            var _ref = _async_to_generator(function() {
                var result;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchData(get, channel.id, targetMessageId)
                            ];
                        case 1:
                            result = _state.sent();
                            if (!result) return [
                                2,
                                setMessages(null)
                            ];
                            if (result.length < 50) setMoreMessageAvailable(false);
                            return [
                                2,
                                setMessages(result)
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (channel) fetch().then();
    }, [
        channel,
        targetMessageId
    ]);
    var retrieveAdditional = function() {
        var _ref = _async_to_generator(function() {
            var skip, result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!messages || !moreMessageAvailable) return [
                            2
                        ];
                        skip = messages.length;
                        return [
                            4,
                            get("/user/channels/".concat(channel.id, "/messages?skip=").concat(skip, "&take=").concat(take))
                        ];
                    case 1:
                        result = _state.sent();
                        if (!result.ok || !result.body) return [
                            2
                        ];
                        setMessages(_to_consumable_array(messages).concat(_to_consumable_array(result.body)));
                        if (result.body.length < take) setMoreMessageAvailable(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function retrieveAdditional() {
            return _ref.apply(this, arguments);
        };
    }();
    var resetReceived = function() {
        return setReceivedMessageId(void 0);
    };
    return {
        messages: messages,
        receivedMessageId: receivedMessageId,
        resetReceived: resetReceived,
        retrieveAdditional: retrieveAdditional,
        moreMessageAvailable: moreMessageAvailable
    };
};
// src/hooks/useScrollToRetrieve.ts
import { useEffect as useEffect15, useState as useState15 } from "react";
var retrievingThreshold = 500;
var useScrollToRetrieve_default = function(ref, hasMessages) {
    var _useState15 = _sliced_to_array(useState15(false), 2), inScrollArea = _useState15[0], setInScrollArea = _useState15[1];
    useEffect15(function() {
        if (!(ref === null || ref === void 0 ? void 0 : ref.current) || !hasMessages) return function() {};
        var listener = function() {
            if (ref.current.scrollTop < retrievingThreshold) setInScrollArea(true);
            else setInScrollArea(false);
        };
        ref.current.addEventListener("scroll", listener);
        return function() {
            var _ref_current;
            ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.removeEventListener("scroll", listener);
        };
    }, [
        hasMessages,
        ref
    ]);
    return inScrollArea;
};
// src/components/MessageView/index.tsx
import { useEffect as useEffect21, useRef as useRef3, useState as useState21 } from "react";
// src/util/getInputHeight.ts
var getInputHeight_default = function(quotedMessage) {
    var baseHeight = 20 * 2 + 2 * 16;
    var rowHeight = 24;
    return rowHeight + baseHeight + (quotedMessage ? 40 : 0);
};
// src/components/MessageView/index.tsx
import styled41 from "styled-components";
// src/types/ContentBlockType.ts
var ContentBlockType = /* @__PURE__ */ function(ContentBlockType2) {
    ContentBlockType2["ElementText"] = "ElementText";
    ContentBlockType2["ElementAudio"] = "ElementAudio";
    ContentBlockType2["ElementVideo"] = "ElementVideo";
    ContentBlockType2["ElementYoutube"] = "ElementYoutube";
    ContentBlockType2["ElementImage"] = "ElementImage";
    ContentBlockType2["ElementLink"] = "ElementLink";
    ContentBlockType2["ElementVimeo"] = "ElementVimeo";
    ContentBlockType2["QuestionOpen"] = "QuestionOpen";
    ContentBlockType2["QuestionBoolean"] = "QuestionBoolean";
    ContentBlockType2["QuestionMultipleChoice"] = "QuestionMultipleChoice";
    return ContentBlockType2;
}(ContentBlockType || {});
var ContentBlockType_default = ContentBlockType;
// src/util/toBool.ts
var toBool_default = function(value) {
    var stringValue = value === null || value === void 0 ? void 0 : value.toString().toLowerCase();
    switch(stringValue){
        case "true":
        case "correct":
        case "1":
            return true;
        case void 0:
        case null:
            return void 0;
        default:
            return false;
    }
};
// src/hooks/useProcessedAnswers.ts
var useProcessedAnswers_default = function(message) {
    var language = useLanguage_default();
    if (!(message === null || message === void 0 ? void 0 : message.content)) return void 0;
    var answer = message.content;
    var hasReview = !!answer.mentorReview && answer.mentorReview.length > 0;
    if (!hasReview) return;
    if (answer.questionType === ContentBlockType_default.QuestionBoolean) {
        var correct = toBool_default(answer.correctAnswer) === true;
        var toString = function(value) {
            return value ? localization_default[language].true : localization_default[language].false;
        };
        var given = toBool_default(answer.textAnswer) === true;
        var valid = correct === given;
        return {
            type: ContentBlockType_default.QuestionBoolean,
            correct: [
                toString(correct)
            ],
            given: [
                toString(given)
            ],
            valid: valid
        };
    }
    if (answer.questionType === ContentBlockType_default.QuestionOpen) {
        var given1 = [
            answer.textAnswer
        ];
        return {
            type: ContentBlockType_default.QuestionOpen,
            given: given1,
            correct: [],
            valid: void 0
        };
    }
    if (answer.questionType === ContentBlockType_default.QuestionMultipleChoice) {
        var correct1 = choicesToString(answer.questionChoices, answer.correctAnswer);
        var given2 = choicesToString(answer.questionChoices, answer.textAnswer);
        var valid1 = correct1 && given2 && correct1.length === given2.length && given2.filter(function(g) {
            return correct1.includes(g);
        }).length === correct1.length;
        return {
            type: ContentBlockType_default.QuestionMultipleChoice,
            correct: correct1,
            given: given2,
            valid: valid1
        };
    }
    return void 0;
};
var choicesToString = function(choices, idString) {
    if (idString === null || idString === "" || idString === void 0) return [];
    var ids = idString.split(",");
    ids = ids.map(function(s) {
        return s.trim();
    });
    var text = [];
    ids.forEach(function(id) {
        if (choices[id] !== void 0 && choices[id] != null && choices[id].length !== 0) text.push(choices[id]);
    });
    return text;
};
// src/hooks/useMessageToString.ts
var useMessageToString_default = function(message) {
    var language = useLanguage_default();
    var answerReview = useMentorAnswerReviewText(message);
    var terms = localization_default[language];
    if (!message) return message;
    switch(message === null || message === void 0 ? void 0 : message.type){
        case MessageType_default.Text:
            return message.content.replace("&nbsp;", " ");
        case MessageType_default.StudentEnrollment:
            var _message_content;
            return terms.studentEnrollment.replace("@course", (_message_content = message.content) === null || _message_content === void 0 ? void 0 : _message_content.courseName).replace("&nbsp;", " ");
        case MessageType_default.MentorAnswerReview:
            return answerReview.replace("&nbsp;", " ");
        case MessageType_default.MentorChangeLeave:
            return terms.mentorChangeLeaveMessage.replace("@course", message.content).replace("&nbsp;", " ");
        case MessageType_default.MentorChangeEnter:
            return terms.mentorChangeEnter.replace("@course", message.content).replace("&nbsp;", " ");
        case MessageType_default.NameChange:
            return terms.nameChangeMessage.replace("@old_name", message.content).replace("@new_name", message === null || message === void 0 ? void 0 : message.senderName).replace("&nbsp;", " ");
        default:
            return null;
    }
};
var useMentorAnswerReviewText = function(message) {
    var language = useLanguage_default();
    var answer = useProcessedAnswers_default(message);
    var terms = localization_default[language];
    if (!message || (message === null || message === void 0 ? void 0 : message.type) !== MessageType_default.MentorAnswerReview) return "";
    if (!answer) return "";
    var text = "".concat(terms.question, "\n").concat(stripTags_default(message.content.questionText), "\n\n").concat(terms.answer, "\n").concat(answer.given.map(function(a) {
        return "".concat(a, "\n");
    }), "\n");
    if (answer.valid === false) {
        text += "".concat(terms.correct, "\n");
        text += "".concat(answer.correct.map(function(a) {
            return "".concat(a, "\n");
        }), "\n");
    }
    return text + message.content.mentorReview;
};
// src/hooks/useMessageMarkAsRead.ts
import { usePut as usePut2 } from "@bbcs/bbcs-fetch";
import { useEffect as useEffect17, useState as useState17 } from "react";
// src/types/IncomingMessage.ts
var isReadByUser = function(message, user) {
    var _message_receivers_find, _message_receivers;
    if (message.isSender) return true;
    var _message_receivers_find_hasRead;
    return (_message_receivers_find_hasRead = (_message_receivers = message.receivers) === null || _message_receivers === void 0 ? void 0 : (_message_receivers_find = _message_receivers.find(function(r) {
        return r.userId === user.id;
    })) === null || _message_receivers_find === void 0 ? void 0 : _message_receivers_find.hasRead) !== null && _message_receivers_find_hasRead !== void 0 ? _message_receivers_find_hasRead : false;
};
// src/hooks/useIntersection.ts
import { useEffect as useEffect16, useState as useState16 } from "react";
function useIntersection(element, rootMargin, firedOnce) {
    var _useState16 = _sliced_to_array(useState16(false), 2), isVisible = _useState16[0], setState = _useState16[1];
    useEffect16(function() {
        if (!(element === null || element === void 0 ? void 0 : element.current)) return function() {};
        var observer = new IntersectionObserver(function(param) {
            var _param = _sliced_to_array(param, 1), entry = _param[0];
            setState(entry.isIntersecting);
            if (entry.isIntersecting && firedOnce) observer.unobserve(element.current);
        }, {
            rootMargin: rootMargin
        });
        observer.observe(element.current);
        return function() {
            if (element === null || element === void 0 ? void 0 : element.current) observer.unobserve(element.current);
        };
    }, []);
    return isVisible;
}
var useIntersection_default = useIntersection;
// src/hooks/useMessageMarkAsRead.ts
function useMessageMarkAsRead(message, channelId, envelop) {
    var user = useChatContext_default().user;
    var markAsRead = useMarkAsReadConnector(message.id, channelId);
    var isVisible = useIntersection_default(envelop, "-10px", false);
    var _useState17 = _sliced_to_array(useState17(void 0), 2), read = _useState17[0], setRead = _useState17[1];
    useEffect17(function() {
        if (!user || read === true) return function() {};
        if (read === void 0) {
            setRead(isReadByUser(message, user));
            return function() {};
        }
        var timeout = setTimeout(function() {
            markAsRead();
            setRead(true);
        }, 5e3);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        message,
        isVisible,
        envelop,
        user,
        markAsRead
    ]);
    return read;
}
var useMarkAsReadConnector = function(messageId, channelId) {
    var connector = useChat_default();
    var put = usePut2();
    var mark = function() {
        if (!connector || !connector.isConnected()) return false;
        try {
            connector === null || connector === void 0 ? void 0 : connector.markMessageAsRead(channelId, messageId);
        } catch (e) {
            return false;
        }
        return true;
    };
    var markAsRead = function() {
        var marked = mark();
        if (marked) return;
        put("/user/messages/".concat(messageId, "/mark-read"), {}).then();
    };
    return markAsRead !== null && markAsRead !== void 0 ? markAsRead : false;
};
var useMessageMarkAsRead_default = useMessageMarkAsRead;
// src/components/MessageView/MessageDetails/Envelop.tsx
import { useRef, useState as useState18 } from "react";
import styled32, { useTheme as useTheme11 } from "styled-components";
// src/components/MessageView/MessageDetails/MessageStatus.tsx
import styled30, { useTheme as useTheme10 } from "styled-components";
// src/components/Shared/DateString.tsx
import { Fragment as Fragment6, jsx as jsx28 } from "react/jsx-runtime";
var DateString_default = function(props) {
    var value = props.value, empty = props.empty;
    var culture = useChatContext_default().culture;
    if (!value) return /* @__PURE__ */ jsx28(Fragment6, {
        children: empty
    });
    var date = parseDate(value);
    return /* @__PURE__ */ jsx28(Fragment6, {
        children: date.toLocaleDateString(culture)
    });
};
var parseDate = function(value) {
    var timestamp = Date.parse("".concat(value, "Z"));
    if (Number.isNaN(timestamp)) timestamp = Date.parse(value);
    return new Date(timestamp);
};
// src/components/MessageView/MessageDetails/MessageStatus.tsx
import { jsx as jsx29, jsxs as jsxs18 } from "react/jsx-runtime";
var MessageStatus_default = function(props) {
    var _message_receivers;
    var message = props.message;
    var user = useChatContext_default().user;
    var theme = useTheme10();
    var isSender = message.isSender === true;
    if (!user || !isSender) return null;
    if (message.sendState === "sending") return /* @__PURE__ */ jsx29(Container10, {
        children: /* @__PURE__ */ jsx29(CheckMark, {
            color: theme.colors.tertiary
        })
    });
    if (message.sendState === "sending-error") return /* @__PURE__ */ jsx29(Container10, {
        children: /* @__PURE__ */ jsx29(CheckMark, {
            color: theme.colors.error
        })
    });
    var isReadByReceivers = ((_message_receivers = message.receivers) === null || _message_receivers === void 0 ? void 0 : _message_receivers.filter(function(r) {
        return r.userId !== user.id && r.hasRead;
    }).length) === message.receivers.length - 1;
    var color = isReadByReceivers ? theme.colors.secondary : theme.colors.tertiary;
    return /* @__PURE__ */ jsxs18(Container10, {
        children: [
            /* @__PURE__ */ jsx29(DateReceived, _object_spread({}, props)),
            /* @__PURE__ */ jsx29(CheckMark, {
                color: color
            }),
            /* @__PURE__ */ jsx29(CheckMark, {
                color: color
            })
        ]
    });
};
var DateReceived = function(props) {
    var message = props.message;
    return /* @__PURE__ */ jsx29("div", {
        className: "message-date",
        children: /* @__PURE__ */ jsx29(DateString_default, {
            value: message.senderDate
        })
    });
};
var Container10 = styled30.div(_templateObject44());
// src/components/MessageView/MessageDetails/QuotedMessage.tsx
import styled31 from "styled-components";
// src/util/clamp.ts
var clamp = function(text, max) {
    if (text.length <= max) return text;
    var subString = text.substring(0, max);
    var space = subString.lastIndexOf(" ");
    var result = space === -1 ? space : subString.substring(0, space);
    return "".concat(result, "…");
};
var clamp_default = clamp;
// src/components/MessageView/MessageDetails/QuotedMessage.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var QuotedMessage_default = function(props) {
    var message = props.message;
    var _stripTags_default;
    var text = clamp_default((_stripTags_default = stripTags_default(message === null || message === void 0 ? void 0 : message.quotedMessage)) !== null && _stripTags_default !== void 0 ? _stripTags_default : "", 60);
    if (isEmpty_default(text)) return null;
    var isSender = message.isSender === true;
    var onClick = function() {
        var _document_getElementById;
        (_document_getElementById = document.getElementById("message_".concat(message.quotedMessageId))) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.scrollIntoView({
            behavior: "smooth"
        });
    };
    return /* @__PURE__ */ jsx30(Quote, {
        onClick: function() {
            return onClick();
        },
        isSender: isSender,
        children: text
    });
};
var Quote = styled31.blockquote(_templateObject45(), function(p) {
    return p.isSender ? 2 : 0;
}, function(p) {
    return p.theme.colors.default;
}, function(p) {
    return p.isSender ? 0 : 2;
}, function(p) {
    return p.theme.colors.default;
}, function(p) {
    return p.theme.colors.default;
}, function(p) {
    return p.isSender ? 12 : 0;
}, function(p) {
    return p.isSender ? 0 : 12;
});
// src/components/MessageView/MessageDetails/Envelop.tsx
import { jsx as jsx31, jsxs as jsxs19 } from "react/jsx-runtime";
var Envelop = function(props) {
    var children = props.children, message = props.message, onQuote = props.onQuote;
    var connector = useChat_default();
    var selectedChannel = useViewContext_default().selectedChannel;
    var ref = useRef(null);
    var _useState18 = _sliced_to_array(useState18(), 2), quoteTime = _useState18[0], setQuoteTimer = _useState18[1];
    var isSender = message.isSender === true;
    var text = useMessageToString_default(message);
    var _useState181 = _sliced_to_array(useState18(false), 2), showTools = _useState181[0], setShowTools = _useState181[1];
    var theme = useTheme11();
    var canQuote = !isEmpty_default(text);
    var markAsRead = useMessageMarkAsRead_default(message, selectedChannel.id, ref);
    var quote = function() {
        if (canQuote) onQuote(message);
    };
    var resend = function() {
        if (!connector) return;
        connector.sendMessage(_object_spread_props(_object_spread({}, message), {
            tempId: message.tempId
        }));
    };
    var onMouseDown = function(event) {
        event.preventDefault();
        var timer = setTimeout(quote, 1500);
        setQuoteTimer(timer);
        return function() {
            return clearTimeout(timer);
        };
    };
    var onMouseUp = function() {
        if (!quoteTime) return;
        clearTimeout(quoteTime);
        setQuoteTimer(void 0);
    };
    var onCopy = function() {
        return navigator.clipboard.writeText(text);
    };
    var canCopy = message.sendState === "success";
    var canReply = message.sendState === "success";
    var canResend = message.sendState === "sending-error";
    return /* @__PURE__ */ jsxs19(Placer, {
        onMouseEnter: function() {
            return setShowTools(true);
        },
        onMouseLeave: function() {
            return setShowTools(false);
        },
        "data-id": message.id,
        ref: ref,
        isSender: isSender,
        children: [
            /* @__PURE__ */ jsx31(Container11, {
                id: "message_".concat(message.id),
                onMouseDown: onMouseDown,
                onTouchStart: onMouseDown,
                onTouchEnd: function() {
                    return onMouseUp();
                },
                onMouseUp: function() {
                    return onMouseUp();
                },
                isSender: isSender,
                children: /* @__PURE__ */ jsxs19(Content2, {
                    isSender: isSender,
                    children: [
                        /* @__PURE__ */ jsx31(Sender, {
                            showName: selectedChannel.type === ChannelType_default.Private,
                            children: message.senderName
                        }),
                        /* @__PURE__ */ jsx31(QuotedMessage_default, _object_spread({}, props)),
                        children,
                        /* @__PURE__ */ jsx31(MessageStatus_default, _object_spread_props(_object_spread({}, props), {
                            markAsRead: markAsRead
                        }))
                    ]
                })
            }),
            /* @__PURE__ */ jsxs19(Tools2, {
                show: showTools && canQuote,
                children: [
                    canCopy && /* @__PURE__ */ jsx31(Copy, {
                        onClick: onCopy,
                        color: theme.colors.default,
                        height: 18
                    }),
                    canReply && /* @__PURE__ */ jsx31(Reply, {
                        onClick: quote,
                        color: theme.colors.default,
                        height: 22
                    }),
                    canResend && /* @__PURE__ */ jsx31(Send, {
                        onClick: resend,
                        color: theme.colors.default,
                        height: 22
                    })
                ]
            })
        ]
    });
};
var Content2 = styled32.div(_templateObject46());
var Placer = styled32.div(_templateObject47(), function(p) {
    return p.isSender ? "row-reverse" : "row";
});
var Tools2 = styled32.div(_templateObject48(), function(p) {
    return p.show ? "inherit" : "hidden";
});
var Container11 = styled32.div(_templateObject49(), function(p) {
    return p.isSender ? p.theme.colors.defaultSupport : p.theme.colors.defaultInverse;
}, function(p) {
    return p.theme.colors.default;
}, function(p) {
    return p.isSender ? "row-reverse" : "row";
}, function(p) {
    return p.isSender ? p.theme.colors.defaultInverse : p.theme.colors.defaultSupport;
}, function(p) {
    return p.theme.colors.secondary;
});
var Sender = styled32.div(_templateObject50(), function(p) {
    return p.showName ? "block" : "none";
});
var Envelop_default = Envelop;
// src/components/MessageView/MessageDetails/BaseMessage.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
var BaseMessage_default = function(props) {
    var message = props.message;
    var text = useMessageToString_default(message);
    if (isEmpty_default(text)) return null;
    return /* @__PURE__ */ jsx32(Envelop_default, _object_spread_props(_object_spread({}, props), {
        children: /* @__PURE__ */ jsx32("div", {
            dangerouslySetInnerHTML: {
                __html: text
            }
        })
    }));
};
// src/components/MessageView/MessageDetails/MentorAnswerReviewMessage.tsx
import styled33, { useTheme as useTheme12 } from "styled-components";
import { Fragment as Fragment7, jsx as jsx33, jsxs as jsxs20 } from "react/jsx-runtime";
var MentorAnswerReviewMessage_default = function(props) {
    var language = useLanguage_default();
    var message = props.message;
    var answer = useProcessedAnswers_default(message);
    if (!answer || answer.given.length === 0) return null;
    return /* @__PURE__ */ jsxs20(Envelop_default, _object_spread_props(_object_spread({}, props), {
        children: [
            /* @__PURE__ */ jsx33(Label, {
                children: localization_default[language].question
            }),
            /* @__PURE__ */ jsx33(Value2, {
                children: stripTags_default(message.content.questionText)
            }),
            /* @__PURE__ */ jsxs20(Label, {
                children: [
                    localization_default[language].answer,
                    " ",
                    /* @__PURE__ */ jsx33(Result, {
                        value: answer.valid
                    })
                ]
            }),
            /* @__PURE__ */ jsx33(Value2, {
                children: answer.given.map(function(a) {
                    return /* @__PURE__ */ jsx33("div", {
                        children: a
                    }, a);
                })
            }),
            answer.valid === false && /* @__PURE__ */ jsxs20(Fragment7, {
                children: [
                    /* @__PURE__ */ jsx33(Label, {
                        children: localization_default[language].correct
                    }),
                    /* @__PURE__ */ jsx33(Value2, {
                        children: answer.correct.map(function(a) {
                            return /* @__PURE__ */ jsx33("div", {
                                children: a
                            }, a);
                        })
                    })
                ]
            }),
            /* @__PURE__ */ jsx33(Label, {
                children: localization_default[language].review
            }),
            /* @__PURE__ */ jsx33(Value2, {
                children: /* @__PURE__ */ jsx33(TextWithLinks_default, {
                    text: message.content.mentorReview
                })
            })
        ]
    }));
};
var Label = styled33.div(_templateObject51(), function(p) {
    return p.theme.colors.error;
});
var Value2 = styled33.div(_templateObject52());
var Result = function(props) {
    var value = props.value;
    var theme = useTheme12();
    if (value !== false) return null;
    return /* @__PURE__ */ jsxs20(Fragment7, {
        children: [
            "(",
            /* @__PURE__ */ jsx33(Close, {
                height: 20,
                color: theme.colors.error
            }),
            ")"
        ]
    });
};
// src/util/getViewUrl.tsx
var getViewUrl_default = function(message) {
    if (message.type === MessageType_default.StudentLessonSubmission) {
        var base = message.isSender ? "/student/submissions/" : "/mentor/submissions/";
        return "".concat(base).concat(message.content.submissionId);
    }
    if (message.type === MessageType_default.MentorLessonSubmissionReview) {
        var viewer = message.isSender ? "mentor" : "student";
        return "/".concat(viewer, "/submissions/").concat(message.content.submissionId);
    }
    return "";
};
// src/components/MessageView/MessageDetails/MentorLessonSubmissionReviewMessage.tsx
import { jsx as jsx34, jsxs as jsxs21 } from "react/jsx-runtime";
var MentorLessonSubmissionReviewMessage_default = function(props) {
    var _message_content_course, _message_content, _message_content_lesson, _message_content1;
    var message = props.message;
    var language = useLanguage_default();
    var terms = localization_default[language];
    var term = terms.mentorLessonSubmissionReview.replace("@course", (_message_content = message.content) === null || _message_content === void 0 ? void 0 : (_message_content_course = _message_content.course) === null || _message_content_course === void 0 ? void 0 : _message_content_course.name).replace("@lesson", (_message_content1 = message.content) === null || _message_content1 === void 0 ? void 0 : (_message_content_lesson = _message_content1.lesson) === null || _message_content_lesson === void 0 ? void 0 : _message_content_lesson.header).replace("&nbsp;", " ");
    var heads = getHead(term, "@url");
    var tails = getTails(term, "@url");
    var url = getViewUrl_default(message);
    return /* @__PURE__ */ jsxs21(Envelop_default, _object_spread_props(_object_spread({}, props), {
        children: [
            heads,
            /* @__PURE__ */ jsx34(Link_default, {
                href: url,
                children: terms.mentorLessonSubmissionReviewLabel
            }),
            tails
        ]
    }));
};
// src/components/MessageView/MessageDetails/StudentLessonSubmissionMessage.tsx
import { jsx as jsx35, jsxs as jsxs22 } from "react/jsx-runtime";
var StudentLessonSubmissionMessage_default = function(props) {
    var _message_content_course, _message_content, _message_content_lesson, _message_content1;
    var message = props.message;
    var language = useLanguage_default();
    var terms = localization_default[language];
    var term = terms.studentLessonSubmission.replace("@course", (_message_content = message.content) === null || _message_content === void 0 ? void 0 : (_message_content_course = _message_content.course) === null || _message_content_course === void 0 ? void 0 : _message_content_course.name).replace("@lesson", (_message_content1 = message.content) === null || _message_content1 === void 0 ? void 0 : (_message_content_lesson = _message_content1.lesson) === null || _message_content_lesson === void 0 ? void 0 : _message_content_lesson.header).replace("&nbsp;", " ");
    var heads = getHead(term, "@url");
    var tails = getTails(term, "@url");
    var url = getViewUrl_default(message);
    return /* @__PURE__ */ jsxs22(Envelop_default, _object_spread_props(_object_spread({}, props), {
        children: [
            heads,
            /* @__PURE__ */ jsx35(Link_default, {
                href: url,
                children: terms.studentLessonSubmissionLabel
            }),
            tails
        ]
    }));
};
// src/components/MessageView/MessageDetails/TextMessage.tsx
import styled34 from "styled-components";
import { jsx as jsx36 } from "react/jsx-runtime";
var TextMessage_default = function(props) {
    var message = props.message, searchTerm = props.searchTerm;
    var text = message.content;
    if (isEmpty_default(text)) return null;
    return /* @__PURE__ */ jsx36(Envelop_default, _object_spread_props(_object_spread({}, props), {
        children: /* @__PURE__ */ jsx36(Text2, {
            children: /* @__PURE__ */ jsx36(TextWithLinks_default, {
                mark: searchTerm,
                text: text
            })
        })
    }));
};
var Text2 = styled34.span(_templateObject53());
// src/components/MessageView/MessageDetails/index.tsx
import { jsx as jsx37 } from "react/jsx-runtime";
var MessageDetails_default = function(props) {
    var message = props.message;
    switch(message.type){
        case MessageType_default.Text:
            return /* @__PURE__ */ jsx37(TextMessage_default, _object_spread({}, props));
        case MessageType_default.MentorAnswerReview:
            return /* @__PURE__ */ jsx37(MentorAnswerReviewMessage_default, _object_spread({}, props));
        case MessageType_default.StudentLessonSubmission:
            return /* @__PURE__ */ jsx37(StudentLessonSubmissionMessage_default, _object_spread({}, props));
        case MessageType_default.MentorLessonSubmissionReview:
            return /* @__PURE__ */ jsx37(MentorLessonSubmissionReviewMessage_default, _object_spread({}, props));
        default:
            return /* @__PURE__ */ jsx37(BaseMessage_default, _object_spread({}, props));
    }
};
// src/components/MessageView/BackBar.tsx
import styled36, { useTheme as useTheme13 } from "styled-components";
// src/components/MessageView/ChannelTools.tsx
import styled35 from "styled-components";
import { jsx as jsx38 } from "react/jsx-runtime";
var ChannelTools_default = function(props) {
    var channel = props.channel, onShowChannelTools = props.onShowChannelTools;
    var onClick = function() {
        return onShowChannelTools(ChannelTool_default.ChannelInfo, channel);
    };
    return /* @__PURE__ */ jsx38(Container12, {
        onClick: onClick,
        children: /* @__PURE__ */ jsx38(Info, {
            children: /* @__PURE__ */ jsx38("span", {
                children: "i"
            })
        })
    });
};
var Container12 = styled35.div(_templateObject54());
var Info = styled35.div(_templateObject55(), function(p) {
    return p.theme.colors.primary;
}, function(p) {
    return p.theme.colors.primaryInverse;
}, function(p) {
    return p.theme.colors.primaryInverse;
});
// src/components/MessageView/BackBar.tsx
import { jsx as jsx39, jsxs as jsxs23 } from "react/jsx-runtime";
var BackBar_default = function(props) {
    var show = props.show, channel = props.channel, back = props.back, online = props.online, onShowChannelTools = props.onShowChannelTools;
    var showChannelTools = useChatContext_default().showChannelTools;
    var theme = useTheme13();
    if (!show) return null;
    return /* @__PURE__ */ jsxs23(Bar2, {
        children: [
            /* @__PURE__ */ jsx39(Div3, {
                onClick: back,
                children: /* @__PURE__ */ jsx39(Left, {
                    color: theme.colors.primary
                })
            }),
            /* @__PURE__ */ jsxs23(Div3, {
                onClick: back,
                children: [
                    channel.name,
                    /* @__PURE__ */ jsx39(Online_default, {
                        show: online
                    })
                ]
            }),
            /* @__PURE__ */ jsx39(Spacer_default, {}),
            showChannelTools && /* @__PURE__ */ jsx39(ChannelTools_default, {
                onShowChannelTools: onShowChannelTools,
                channel: channel
            })
        ]
    });
};
var Div3 = styled36.div(_templateObject56(), function(p) {
    return p.theme.colors.primary;
}, function(p) {
    return p.theme.colors.secondary;
}, function(p) {
    return p.theme.colors.secondary;
});
var Bar2 = styled36.div(_templateObject57(), function(p) {
    return p.theme.colors.defaultSupport;
});
// src/components/MessageView/MessageView.styled.tsx
import styled37 from "styled-components";
var Container13 = styled37.div(_templateObject58());
var Messages = styled37.div(_templateObject59(), function(p) {
    return p.top;
}, function(p) {
    return p.inputHeight;
}, function(p) {
    return p.theme.colors.defaultInverse;
}, function(p) {
    return p.theme.colors.defaultSupport;
});
// src/components/MessageView/Loading.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
var Loading_default2 = function() {
    return /* @__PURE__ */ jsx40(Container13, {
        children: /* @__PURE__ */ jsx40(Center_default, {
            children: /* @__PURE__ */ jsx40(Spinner_default, {
                paddingTop: 60,
                color: "primary",
                size: "normal",
                center: true
            })
        })
    });
};
// src/components/MessageView/MessageInput.tsx
import { usePost as usePost3, uuid } from "@bbcs/bbcs-fetch";
// src/components/Shared/TextArea.tsx
import { useContext as useContext4, useRef as useRef2 } from "react";
import styled38 from "styled-components";
import { jsx as jsx41 } from "react/jsx-runtime";
var TextArea_default = function(props) {
    var value = props.value, onChange = props.onChange, onKeyUp = props.onKeyUp;
    var ref = useRef2(null);
    var _useContext4 = useContext4(ChatContext_default), onFocusModeEnter = _useContext4.onFocusModeEnter, onFocusModeLeave = _useContext4.onFocusModeLeave;
    var onFocus = function() {
        if (onFocusModeEnter) {
            onFocusModeEnter();
        }
    };
    var onBlur = function() {
        if (onFocusModeLeave) {
            onFocusModeLeave();
        }
    };
    return /* @__PURE__ */ jsx41("div", {
        children: /* @__PURE__ */ jsx41(TextArea, {
            onChange: function(event) {
                return onChange(event.target.value);
            },
            value: value !== null && value !== void 0 ? value : "",
            ref: ref,
            onKeyUp: onKeyUp,
            onFocus: onFocus,
            onBlur: onBlur
        })
    });
};
var TextArea = styled38.textarea(_templateObject60(), function(p) {
    return p.theme.colors.tertiary;
}, function(p) {
    return p.theme.colors.default;
}, function(p) {
    return p.theme.colors.primary;
}, function(p) {
    return p.theme.colors.primary;
}, function(p) {
    return p.theme.colors.tertiary;
});
// src/hooks/useIsConnected.ts
import { useEffect as useEffect18, useReducer } from "react";
var useIsConnected_default = function() {
    var connector = useChat_default();
    var _useReducer = _sliced_to_array(useReducer(function(x) {
        return x + 1;
    }, 0), 2), forceUpdate = _useReducer[1];
    useEffect18(function() {
        if (!connector) {
            forceUpdate();
            return function() {};
        }
        connector.onDisconnected.addListener(forceUpdate);
        connector.onConnected.addListener(forceUpdate);
        return function() {
            connector.onConnected.removeListener(forceUpdate);
            connector.onDisconnected.removeListener(forceUpdate);
        };
    }, [
        connector
    ]);
    return (connector === null || connector === void 0 ? void 0 : connector.isConnected()) === true;
};
// src/hooks/useMediaQuery.ts
import { useState as useState19, useEffect as useEffect19 } from "react";
var useMediaQuery = function(query) {
    var _useState19 = _sliced_to_array(useState19(window.matchMedia("(".concat(query, ")")).matches), 2), matches = _useState19[0], setMatches = _useState19[1];
    useEffect19(function() {
        var media = window.matchMedia("(".concat(query, ")"));
        setMatches(media.matches);
        var listener = function(event) {
            setMatches(event.matches);
        };
        media.addEventListener("change", listener);
        return function() {
            return media.removeEventListener("change", listener);
        };
    }, [
        query
    ]);
    return matches;
};
var useMediaQuery_default = useMediaQuery;
// src/hooks/useIsMobile.ts
var useIsMobile_default = function() {
    var minWidthForComposedView = useChatContext_default().minWidthForComposedView;
    return !useMediaQuery_default("min-width: ".concat(minWidthForComposedView, "px"));
};
// src/components/MessageView/MessageInput.tsx
import { useEffect as useEffect20, useState as useState20 } from "react";
import styled40, { useTheme as useTheme15 } from "styled-components";
// src/components/MessageView/QuotedMessage.tsx
import styled39, { useTheme as useTheme14 } from "styled-components";
import { jsx as jsx42, jsxs as jsxs24 } from "react/jsx-runtime";
var QuotedMessage_default2 = function(props) {
    var quotedMessage = props.quotedMessage, stopQuoting = props.stopQuoting;
    var theme = useTheme14();
    var text = stripTags_default(quotedMessage);
    if (isEmpty_default(quotedMessage)) return null;
    return /* @__PURE__ */ jsxs24(Container14, {
        children: [
            /* @__PURE__ */ jsx42(Text3, {
                children: text
            }),
            /* @__PURE__ */ jsx42(CloseButton2, {
                onClick: function() {
                    return stopQuoting();
                },
                children: /* @__PURE__ */ jsx42(Close, {
                    height: 24,
                    color: theme.colors.defaultInverse
                })
            })
        ]
    });
};
var Text3 = styled39.div(_templateObject61());
var Container14 = styled39.div(_templateObject62(), function(p) {
    return p.theme.colors.secondary;
}, function(p) {
    return p.theme.colors.secondaryInverse;
});
var CloseButton2 = styled39.div(_templateObject63());
// src/components/MessageView/MessageInput.tsx
import { jsx as jsx43, jsxs as jsxs25 } from "react/jsx-runtime";
var padding = 20;
var MessageInput_default = function(props) {
    var isMobile = useIsMobile_default();
    var theme = useTheme15();
    var connector = useChat_default();
    var _useState20 = _sliced_to_array(useState20(), 2), response = _useState20[0], setResponse = _useState20[1];
    var language = useLanguage_default();
    var quoted = props.quoted, height = props.height, channel = props.channel, stopQuoting = props.stopQuoting, onMessageSend = props.onMessageSend;
    var user = useChatContext_default().user;
    var quotedMessage = useMessageToString_default(quoted);
    var post = usePost3();
    var isConnected = useIsConnected_default();
    var label = isMobile ? null : localization_default[language].send;
    var icon = isMobile ? /* @__PURE__ */ jsx43(Send, {
        color: theme.colors.defaultInverse
    }) : null;
    var clear = function() {
        setResponse(void 0);
        stopQuoting();
    };
    useEffect20(clear, [
        channel
    ]);
    var onSend = function() {
        var _ref = _async_to_generator(function() {
            var message;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (isEmpty_default(response) || !isConnected) return [
                            2
                        ];
                        message = {
                            content: response,
                            channelId: channel.id,
                            tempId: uuid(),
                            quotedMessageId: quoted === null || quoted === void 0 ? void 0 : quoted.id,
                            quotedMessage: quotedMessage,
                            quotedUser: quoted === null || quoted === void 0 ? void 0 : quoted.senderName,
                            senderId: user.id,
                            senderName: user.name,
                            receivers: _to_consumable_array(channel.receivers)
                        };
                        if (!(connector === null || connector === void 0 ? void 0 : connector.isConnected)) return [
                            3,
                            1
                        ];
                        connector.sendMessage(message);
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            post("/user/channels/".concat(channel.id, "/messages"), message)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        clear();
                        onMessageSend();
                        return [
                            2
                        ];
                }
            });
        });
        return function onSend() {
            return _ref.apply(this, arguments);
        };
    }();
    var texAreaHeight = height - (quoted ? 40 : 0);
    var onKeyUp = function() {
        var _ref = _async_to_generator(function(event) {
            var enterPress, withSecondary;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        enterPress = event.key === "Enter" || event.code === "Enter";
                        if (!enterPress) return [
                            2
                        ];
                        withSecondary = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
                        if (!withSecondary) return [
                            3,
                            2
                        ];
                        event.preventDefault();
                        return [
                            4,
                            onSend()
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function onKeyUp(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /* @__PURE__ */ jsxs25(Container15, {
        height: height,
        children: [
            /* @__PURE__ */ jsx43(QuotedMessage_default2, {
                quotedMessage: quotedMessage,
                stopQuoting: stopQuoting
            }),
            /* @__PURE__ */ jsxs25(Border, {
                height: texAreaHeight,
                children: [
                    /* @__PURE__ */ jsx43(TextAreaContainer, {
                        height: texAreaHeight,
                        children: /* @__PURE__ */ jsx43(TextArea_default, {
                            onChange: setResponse,
                            value: response,
                            onKeyUp: onKeyUp
                        })
                    }),
                    /* @__PURE__ */ jsx43(ButtonGroup, {
                        children: /* @__PURE__ */ jsx43(Button_default, {
                            color: isConnected ? "primary" : "tertiary",
                            onClick: onSend,
                            label: label,
                            icon: icon
                        })
                    })
                ]
            })
        ]
    });
};
var Container15 = styled40.div(_templateObject64(), function(p) {
    return p.height;
});
var ButtonGroup = styled40.div(_templateObject65());
var TextAreaContainer = styled40.div(_templateObject66(), function(p) {
    return p.height - padding * 2;
});
var Border = styled40.div(_templateObject67(), function(p) {
    return p.height;
}, padding);
// src/components/MessageView/scrollToMessage.ts
var scrollToMessage_default = function(ref, messageId) {
    if (!messageId) return;
    var parent = ref.current ? ref.current : void 0;
    var envelop = parent === null || parent === void 0 ? void 0 : parent.querySelector('[data-id="'.concat(messageId, '"]'));
    if (!envelop) return;
    var rect = envelop.getBoundingClientRect();
    parent.scroll({
        top: rect.top + 180,
        behavior: "instant"
    });
    envelop.scrollIntoView();
};
// src/components/MessageView/index.tsx
import { jsx as jsx44, jsxs as jsxs26 } from "react/jsx-runtime";
var MessageView_default = function(props) {
    var ref = useRef3();
    var searchTerm = props.searchTerm;
    var _useViewContext_default = useViewContext_default(), selectedChannel = _useViewContext_default.selectedChannel, targetMessageId = _useViewContext_default.targetMessageId, viewMode = _useViewContext_default.viewMode, onBackToChannelOverview = _useViewContext_default.onBackToChannelOverview, onShowChannelTool = _useViewContext_default.onShowChannelTool;
    var state = useChannelState_default(selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.id);
    var _useState21 = _sliced_to_array(useState21(), 2), quotedMessage = _useState21[0], setQuotedMessage = _useState21[1];
    var _useState211 = _sliced_to_array(useState21("none"), 2), forceScroll = _useState211[0], setForceScroll = _useState211[1];
    var _useState212 = _sliced_to_array(useState21(false), 2), retrieving = _useState212[0], setRetrievingMore = _useState212[1];
    var _useMessages_default = useMessages_default(selectedChannel, targetMessageId), messages = _useMessages_default.messages, retrieveAdditional = _useMessages_default.retrieveAdditional, resetReceived = _useMessages_default.resetReceived, receivedMessageId = _useMessages_default.receivedMessageId, moreMessageAvailable = _useMessages_default.moreMessageAvailable;
    var _useChatContext_default = useChatContext_default(), user = _useChatContext_default.user, showChannelTools = _useChatContext_default.showChannelTools;
    var _messages_length;
    var retrieveMore = useScrollToRetrieve_default(ref, ((_messages_length = messages === null || messages === void 0 ? void 0 : messages.length) !== null && _messages_length !== void 0 ? _messages_length : 0) !== 0);
    useEffect21(function() {
        setForceScroll(targetMessageId ? "target" : "end");
    }, [
        selectedChannel,
        targetMessageId,
        viewMode
    ]);
    useEffect21(function() {
        if (!retrieveMore || retrieving) return;
        setRetrievingMore(true);
        retrieveAdditional().then(function() {
            setRetrievingMore(false);
        });
    }, [
        retrieveMore
    ]);
    useEffect21(function() {
        if (!(ref === null || ref === void 0 ? void 0 : ref.current) || !messages) return;
        if (forceScroll === "end") ref.current.scroll({
            top: ref.current.scrollHeight,
            behavior: "instant"
        });
        if (forceScroll === "target") scrollToMessage_default(ref, targetMessageId);
        if (forceScroll !== "none") setForceScroll("none");
    }, [
        ref,
        forceScroll,
        messages,
        targetMessageId
    ]);
    useEffect21(function() {
        var _ref_current_lastElementChild;
        if (!(ref === null || ref === void 0 ? void 0 : ref.current) || !receivedMessageId) return;
        var _ref_current_lastElementChild_scrollHeight;
        var childHeight = (_ref_current_lastElementChild_scrollHeight = (_ref_current_lastElementChild = ref.current.lastElementChild) === null || _ref_current_lastElementChild === void 0 ? void 0 : _ref_current_lastElementChild.scrollHeight) !== null && _ref_current_lastElementChild_scrollHeight !== void 0 ? _ref_current_lastElementChild_scrollHeight : 0;
        var scrollDistance = ref.current.scrollHeight - ref.current.offsetHeight - childHeight - ref.current.scrollTop;
        if (scrollDistance < 20) scrollToMessage_default(ref, receivedMessageId);
        resetReceived();
    }, [
        receivedMessageId
    ]);
    if (viewMode === ViewMode_default.Channel || !selectedChannel || !user) return null;
    if (!messages) return /* @__PURE__ */ jsx44(Loading_default2, {});
    var details = [];
    for(var index = messages.length - 1; index >= 0; index--){
        var message = messages[index];
        details.push(/* @__PURE__ */ jsx44(MessageDetails_default, {
            searchTerm: searchTerm,
            onQuote: setQuotedMessage,
            message: message
        }, message.id));
    }
    var top = viewMode !== ViewMode_default.Both ? 60 : 0;
    var online = isOnline_default(selectedChannel, state, user);
    var inputHeight = getInputHeight_default(quotedMessage);
    var isMobile = viewMode === ViewMode_default.Messages;
    return /* @__PURE__ */ jsxs26(Container13, {
        style: {
            position: "relative"
        },
        children: [
            /* @__PURE__ */ jsx44(Tools3, {
                className: "tools",
                children: !isMobile && showChannelTools && /* @__PURE__ */ jsx44(ChannelTools_default, {
                    channel: selectedChannel,
                    onShowChannelTools: onShowChannelTool
                })
            }),
            /* @__PURE__ */ jsx44(BackBar_default, {
                onShowChannelTools: onShowChannelTool,
                online: online,
                show: isMobile,
                channel: selectedChannel,
                back: onBackToChannelOverview
            }),
            /* @__PURE__ */ jsxs26(Messages, {
                ref: ref,
                inputHeight: inputHeight,
                top: top,
                className: "messages",
                children: [
                    retrieving && moreMessageAvailable && /* @__PURE__ */ jsx44(Spinner_default, {
                        center: true,
                        color: "primary"
                    }),
                    details
                ]
            }),
            /* @__PURE__ */ jsx44(MessageInput_default, {
                quoted: quotedMessage,
                height: inputHeight,
                stopQuoting: function() {
                    setQuotedMessage(void 0);
                },
                channel: selectedChannel,
                onMessageSend: function() {
                    return setForceScroll("end");
                }
            })
        ]
    });
};
var Tools3 = styled41.div(_templateObject68());
// src/hooks/useFetchChannels.ts
import { useGetAsync as useGetAsync4 } from "@bbcs/bbcs-fetch";
import { useEffect as useEffect22, useReducer as useReducer2, useState as useState22 } from "react";
var useFetchChannels = function() {
    var _useReducer2 = _sliced_to_array(useReducer2(function(x) {
        return x + 1;
    }, 0), 2), value = _useReducer2[0], onReloadChannels = _useReducer2[1];
    var _useState22 = _sliced_to_array(useState22(void 0), 2), channels = _useState22[0], setChannels = _useState22[1];
    var get = useGetAsync4();
    useEffect22(function() {
        get("/user/channels").then(function(response) {
            if (!response.ok) setChannels(null);
            else setChannels(response === null || response === void 0 ? void 0 : response.body);
        });
    }, [
        value
    ]);
    return {
        channels: channels,
        onReloadChannels: onReloadChannels
    };
};
// src/context/useViewContextBuilder.ts
import { useEffect as useEffect25, useState as useState25 } from "react";
// src/hooks/useSelectedChannel.ts
import { useEffect as useEffect23, useState as useState23 } from "react";
var useSelectedChannel_default = function(channels, initialChannelId) {
    var _useState23 = _sliced_to_array(useState23(), 2), selectedChannel = _useState23[0], setSelected = _useState23[1];
    var _selectedChannel_id, _ref;
    var channelId = (_ref = (_selectedChannel_id = selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.id) !== null && _selectedChannel_id !== void 0 ? _selectedChannel_id : initialChannelId) !== null && _ref !== void 0 ? _ref : -1;
    var isMobile = useIsMobile_default();
    useEffect23(function() {
        if (!channels || channels.length === 0) return;
        var _channels_find;
        var selected = (_channels_find = channels.find(function(c) {
            return c.id === channelId;
        })) !== null && _channels_find !== void 0 ? _channels_find : !isMobile ? channels[0] : void 0;
        setSelected(selected);
    }, [
        channels,
        initialChannelId
    ]);
    return {
        selectedChannel: selectedChannel,
        setSelected: setSelected
    };
};
// src/hooks/onChannelReceiversChanged.ts
import { useEffect as useEffect24, useState as useState24 } from "react";
var useOnChannelReceiversChanged = function() {
    var connector = useChat_default();
    var _useState24 = _sliced_to_array(useState24(void 0), 2), value = _useState24[0], setChannelReceivers = _useState24[1];
    useEffect24(function() {
        if (!connector) return function() {};
        connector.onChannelReceiversChanged.addListener(setChannelReceivers);
        return function() {
            connector.onChannelReceiversChanged.removeListener(setChannelReceivers);
        };
    }, [
        connector
    ]);
    return value;
};
// src/context/useViewContextBuilder.ts
var useViewContextBuilder_default = function(channels, initialChannelId, reloadChannels) {
    var user = useChatContext_default().user;
    var _useState25 = _sliced_to_array(useState25(ChannelTool_default.ChannelView), 2), channelTool = _useState25[0], setChannelTool = _useState25[1];
    var _useState251 = _sliced_to_array(useState25("channels"), 2), mode = _useState251[0], setMode = _useState251[1];
    var _useState252 = _sliced_to_array(useState25(false), 2), initialSwitched = _useState252[0], setInitialSwitched = _useState252[1];
    var _useSelectedChannel_default = useSelectedChannel_default(channels, initialChannelId), selectedChannel = _useSelectedChannel_default.selectedChannel, setSelected = _useSelectedChannel_default.setSelected;
    var onChannelChanged = useChatContext_default().onChannelChanged;
    var isMobile = useIsMobile_default();
    var receivers = useOnChannelReceiversChanged();
    useEffect25(function() {
        if (!initialChannelId) setMode("channels");
    }, [
        initialChannelId
    ]);
    useEffect25(function() {
        if (!receivers) return;
        var leaveChannel = receivers.channelId === (selectedChannel === null || selectedChannel === void 0 ? void 0 : selectedChannel.id) && !receivers.receivers.includes(user.id);
        if (leaveChannel) setSelected(void 0);
        reloadChannels();
    }, [
        receivers,
        user
    ]);
    useEffect25(function() {
        if (!selectedChannel || initialSwitched || !initialChannelId) return;
        setInitialSwitched(true);
        onShowMessages(selectedChannel);
    }, [
        initialChannelId,
        initialSwitched,
        selectedChannel
    ]);
    var onShowMessages = function(channel) {
        if (onChannelChanged) onChannelChanged(channel.id);
        setSelected(channel);
        setMode("messages");
    };
    var onShowChannelTool = function(tool) {
        setMode("channels");
        setChannelTool(tool);
    };
    var onBackToChannelOverview = function() {
        if (onChannelChanged) onChannelChanged(void 0);
        setMode("channels");
        setChannelTool(ChannelTool_default.ChannelView);
    };
    var onCloseChannelTool = function() {
        setMode("messages");
        setChannelTool(ChannelTool_default.ChannelView);
    };
    var viewMode = getViewMode(isMobile, mode);
    return {
        selectedChannel: selectedChannel,
        viewMode: viewMode,
        onShowMessages: onShowMessages,
        onCloseChannelTool: onCloseChannelTool,
        onShowChannelTool: onShowChannelTool,
        onBackToChannelOverview: onBackToChannelOverview,
        channelTool: channelTool,
        isMobile: isMobile,
        channels: channels
    };
};
var getViewMode = function(isMobile, mode) {
    if (!isMobile) return ViewMode_default.Both;
    return mode === "channels" ? ViewMode_default.Channel : ViewMode_default.Messages;
};
// src/components/ChatPanel.tsx
import { jsx as jsx45, jsxs as jsxs27 } from "react/jsx-runtime";
var ChatPanel_default = function(props) {
    var initialChannelId = props.initialChannelId, initialMessageId = props.initialMessageId, showBackToDashboard = props.showBackToDashboard;
    var channelId = useInitialMessage_default(initialMessageId, initialChannelId);
    var _useFetchChannels = useFetchChannels(), channels = _useFetchChannels.channels, onReloadChannels = _useFetchChannels.onReloadChannels;
    if (!channels || channelId === null) return /* @__PURE__ */ jsx45(Spinner_default, {
        size: "normal",
        color: "primary",
        paddingTop: 120,
        center: true
    });
    if (channels.length === 0) return /* @__PURE__ */ jsx45(NoChannels_default, {});
    return /* @__PURE__ */ jsx45(Component, {
        showBackToDashboard: showBackToDashboard,
        channels: channels,
        initialMessageId: initialMessageId,
        initialChannelId: channelId,
        onReloadChannels: onReloadChannels
    });
};
var Component = function(props) {
    var initialChannelId = props.initialChannelId, initialMessageId = props.initialMessageId, channels = props.channels, _props_showBackToDashboard = props.showBackToDashboard, showBackToDashboard = _props_showBackToDashboard === void 0 ? true : _props_showBackToDashboard, onReloadChannels = props.onReloadChannels;
    var viewContext = useViewContextBuilder_default(channels, initialChannelId, onReloadChannels);
    var onShowMessages = viewContext.onShowMessages;
    var _useState26 = _sliced_to_array(useState26(initialMessageId !== null && initialMessageId !== void 0 ? initialMessageId : void 0), 2), targetMessageId = _useState26[0], setTarget = _useState26[1];
    var _useState261 = _sliced_to_array(useState26(), 2), search = _useState261[0], setSearch = _useState261[1];
    var onBrowseToMessage = function(messageId, channel, searchTerm) {
        onShowMessages(channel);
        setTarget(messageId);
        setSearch(searchTerm);
    };
    var context = _object_spread_props(_object_spread({}, viewContext), {
        onReloadChannels: onReloadChannels,
        targetMessageId: targetMessageId,
        showBackToDashboard: showBackToDashboard
    });
    return /* @__PURE__ */ jsx45(Content3, {
        onBrowseToMessage: onBrowseToMessage,
        viewContext: context,
        searchTerm: search,
        showBackToDashboard: showBackToDashboard
    });
};
var Content3 = function(props) {
    var viewContext = props.viewContext, onBrowseToMessage = props.onBrowseToMessage, searchTerm = props.searchTerm, showBackToDashboard = props.showBackToDashboard;
    var viewMode = viewContext.viewMode;
    var displayMessages = viewMode !== ViewMode_default.Channel;
    var displayChannels = viewMode !== ViewMode_default.Messages;
    return /* @__PURE__ */ jsx45(ViewContext_default.Provider, {
        value: viewContext,
        children: /* @__PURE__ */ jsxs27(Container16, {
            children: [
                displayChannels && /* @__PURE__ */ jsx45(ChannelsColumn_default, {
                    onBrowseToMessage: onBrowseToMessage,
                    showBackToDashboard: showBackToDashboard
                }),
                displayMessages && /* @__PURE__ */ jsx45(MessageView_default, {
                    searchTerm: searchTerm
                })
            ]
        })
    });
};
var Container16 = styled42.div(_templateObject69());
// src/components/Chat.tsx
import { useEffect as useEffect26 } from "react";
import { jsx as jsx46 } from "react/jsx-runtime";
var Chat_default = function(props) {
    var initialChannelId = props.initialChannelId, showBackToDashboard = props.showBackToDashboard, initialMessageId = props.initialMessageId;
    var context = _object_spread({}, props);
    var fetchContext = useFetchContext();
    useEffect26(function() {
        if (context && (fetchContext === null || fetchContext === void 0 ? void 0 : fetchContext.user)) connect(fetchContext, context.user);
    }, [
        context,
        fetchContext
    ]);
    if (!context || !(fetchContext === null || fetchContext === void 0 ? void 0 : fetchContext.user)) return null;
    return /* @__PURE__ */ jsx46(ChatContext_default.Provider, {
        value: context,
        children: /* @__PURE__ */ jsx46(ChatPanel_default, {
            initialChannelId: initialChannelId,
            initialMessageId: initialMessageId,
            showBackToDashboard: showBackToDashboard
        })
    });
};
export { Avatar_default as Avatar, Chat_default as Chat, SnackBar_default as SnackBar, connect, disconnect, useChat_default as useChat };
